import React from 'react';
import { fetchFixedAttributeDisplayNames } from '../../hooks/useFixedAttributeDisplayNames';
import BasePage from '../base';
import { css, StyleSheet } from 'aphrodite';
import { convertPxToRem, getOrderStatusDisplay, getValueFromObjectByKeys } from '../../helper';
import TextBase from '../../common/text';
import { Colors } from '../../themes/Colors';
import { sizeOfBaseButton } from '../../utils/defined';
import { connect } from 'react-redux';
import withNavigate from '../../component/WithNavigate';
import {
  Col,
  Dropdown,
  Row,
  Table,
  DatePicker,
  Menu,
  Checkbox,
  Divider,
  Select as AntSelect,
  Modal,
  Tooltip
} from 'antd';
import { SVGImageComponentReact } from '../../themes/Images';
import CustomSpinner from '../../common/CustomSpinner';
import { FormControl, Select, MenuItem } from '@mui/material';
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './CustomDropdown.css';
import { Line, Column, Pie } from '@ant-design/plots';
import { UserAction } from '../../redux/action';
import moment from 'moment/moment';
import { ROUTER_NAME } from '../../router/routers';
import APIManager from '../../connection/ApiManager';
import { translate } from '../../helper';
import LocalStorage from '../../defined/localStorage';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import './CustomDropdown.css';
import iconCal from '../../assets/image/png/calender.png';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import {
  buildQueryString,
  getSessionFilter,
  resolveCssVarValue,
  setSessionFilter
} from '../../utils/CommonFunction';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import Utils from '../../utils';
import CloseIcon from '@mui/icons-material/Close';
import PageTitleHeader from '../../common/page-title-header';

dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
const dateFormat = 'YYYY-MM-DD';
const US_DATE_FORMAT = 'MM-DD-YYYY';
const { RangePicker } = DatePicker;
const formatRevenue = (value) => {
  if (!value) return '$0';
  const num = parseFloat(value);
  if (num >= 1000) {
    return `$${(num / 1000).toFixed(2)}K`;
  }
  return `$${num.toFixed(2)}`;
};
const formatNumber = (value) => {
  if (!value && value !== 0) return '0';

  const num = Number(value);
  return num.toLocaleString('en-US');
};
const brand = JSON.parse(LocalStorage.getItem('branding'));
const chartRem = (rem) => {
  try {
    if (typeof window !== 'undefined' && window.getComputedStyle) {
      const rootSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      if (!isNaN(rootSize) && rootSize > 0) return rem * rootSize;
    }
  } catch (e) {}
  return rem * 16;
};
const headerTextStyle = {
  fontSize: 'calc(var(--fs-xs)*1.32075)',
  color: 'rgba(106, 106, 137, 1)',
  fontWeight: 500
};
const cardColors = [
  { accent: '#3B5BDB' }, // Orders - Muted Indigo
  { accent: '#0CA678' }, // Quotes - Muted Teal
  { accent: '#E67700' }, // SMS - Muted Amber
  { accent: '#6741D9' }, // Acceptance - Muted Violet
  { accent: '#C2255C' }, // Revenue - Muted Rose
  { accent: '#0C8599' } // Reply Time - Muted Cyan
];

const kpiCardShadow = `
  0px 1px 3px rgba(16, 24, 40, 0.04),
  0px 2px 6px rgba(16, 24, 40, 0.08)
`;

const kpiCardHoverShadow = `
  0px 2px 6px rgba(16, 24, 40, 0.08),
  0px 8px 20px rgba(16, 24, 40, 0.12)
`;
const buildPageList = (current, totalPages, siblings = 1, boundaries = 1) => {
  const clamp = (n, min, max) => Math.max(min, Math.min(n, max));
  const range = (start, end) =>
    start > end ? [] : Array.from({ length: end - start + 1 }, (_, i) => start + i);

  if (totalPages <= 0) return [];

  const currrentPage = clamp(current, 1, totalPages);
  const sib = Math.max(0, siblings);
  const bound = Math.max(0, boundaries);

  const startPages = range(1, Math.min(bound, totalPages));
  const endPages = range(Math.max(totalPages - bound + 1, bound + 1), totalPages);

  const left = Math.max(currrentPage - sib, bound + 1);
  const right = Math.min(currrentPage + sib, totalPages - bound);

  const middle = range(left, right);

  const leftEllipsis = left > bound + 1 ? ['...'] : [];
  const rightEllipsis = right < totalPages - bound ? ['...'] : [];

  return [...startPages, ...leftEllipsis, ...middle, ...rightEllipsis, ...endPages];
};
const heightOfBottomBlackAlpha = `calc(var(--fs-hero)*6.69)`;

const styles = StyleSheet.create({
  container: {
    textAlign: 'left',
    whiteSpace: 'pre-line',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6) calc(var(--sp-md2)*1)'
  },
  bottomBlackAlpha: {
    width: '100%',
    minWidth: '100vw',
    height: heightOfBottomBlackAlpha,
    backgroundColor: Colors.black80,
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 1,
    position: 'absolute'
  },
  bgOverlay: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background:
      'linear-gradient(90deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.56) 100%)',
    zIndex: 1,
    overflow: 'hidden'
  },
  wrapText: {
    position: 'relative',
    zIndex: 4,
    maxWidth: '50%',
    height: '100%',
    minHeight: 'calc(var(--fs-hero)*9.43396)',
    paddingLeft: 'calc(var(--sp-lg)*4.71698)'
  },
  buttonAction: {
    width: sizeOfBaseButton.width,
    height: sizeOfBaseButton.height,
    marginBottom: 'calc(var(--sp-lg)*1.556603)'
  }
});

function roundDownToNearest(number, powerOfTen) {
  const factor = Math.pow(10, powerOfTen);
  return Math.floor(number / factor) * factor;
}
const dashboardContent = [
  { title: 'ordersReceived', key: 'order_received' },
  { title: 'quotesSent', key: 'quote_sent' },
  { title: 'smsSent', key: 'sms_count' },
  { title: 'acceptanceRate', key: 'acceptance_rate' },
  { title: 'revenue', key: 'revenue' },
  { title: 'averageReplyTime', key: 'average_reply_time' }
];

const metricDescriptions = {
  acceptance_rate: 'Quotes accepted ÷ Quotes sent',
  average_reply_time: 'Average time between order receive to the quote sent'
};

function formatReplyTime(sec) {
  if (sec === null || sec === undefined || isNaN(sec)) return '0s';

  const total = Math.floor(Number(sec));

  const months = Math.floor(total / 2592000); // 30 days
  const days = Math.floor((total % 2592000) / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  if (months > 0) return `${months}mo ${days}d`;
  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;
  return `${seconds}s`;
}

const rangePresets = [
  {
    label: <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>Today</span>,
    value: [dayjs(), dayjs()]
  },
  {
    label: <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>Yesterday</span>,
    value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')]
  },
  {
    label: <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>Last 7 Days</span>,
    value: [dayjs().subtract(6, 'day'), dayjs()]
  },
  {
    label: <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>Last 30 Days</span>,
    value: [dayjs().subtract(29, 'day'), dayjs()]
  },
  {
    label: <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>Last 6 Months</span>,
    value: [dayjs().subtract(5, 'month').startOf('day'), dayjs()]
  },
  {
    label: <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>Last Year</span>,
    value: [dayjs().subtract(1, 'year').add(1, 'day').startOf('day'), dayjs()]
  },
  {
    label: <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>All Time</span>,
    value: [dayjs('2000-01-01'), dayjs()]
  }
];
class Analytics extends BasePage {
  constructor(props) {
    super(props);
    this.title = translate('analytics');
    const today = dayjs();
    const twoWeekAgo = dayjs().subtract(13, 'day');
    this.state = {
      showOrdersMonthSelect: false,
      selectedMonth: moment().format('MMMM'),
      dataChartArea: null,
      quoteSummary: [],
      ordersSent: 0,
      ordersAccepted: 0,
      quotesSent: 0,
      locations: 0,
      selectedId: '',
      radios: [
        { name: 'Numbers', selected: true },
        { name: 'Values', selected: false }
      ],
      orders: [],
      loading: false,
      textSearch: '',
      selectedDateRange: [twoWeekAgo, today],
      showFilterOrder: false,
      filterOrdersCreated: 'monthly',
      filterOrdersCreatedBar: 'month',
      filterOrders: 'yearly',
      filterType: 'Numbers',
      filters: ['orders_received', 'orders_accepted', 'quotes_sent', 'accepted_quotes'],
      value_of_accepted_quotes: null,
      percentage_change: null,
      filter: 'yearly',
      page: 1,
      pageSize: 15,
      totalOrders: 0,
      dashboardData: [],
      ordersQuotesData: [],
      pickupDeliveryData: [],
      pickupDeliveryTrendData: [],
      revenueTrendData: [],
      chartHeight: resolveCssVarValue('--fs-hero') * 9.43396,
      revenueByOrderTypeData: [],
      revenueByLocationData: [],
      newRepeatCustomersPie: [],
      kpiCardHeight: null,
      kpiMeasuring: false,
      kpiLoading: false,
      customerPreferenceData: [],
      pendingOrdersData: [],
      pickupDeliveryLoading: false,
      revenueTrendLoading: false,
      revenueByOrderTypeLoading: false,
      revenueByLocationLoading: false,
      newRepeatCustomersLoading: false,
      customerPreferenceLoading: false,
      pendingOrdersLoading: false,
      latestOrdersLoading: false,
      latestOrdersPage: 1,
      latestOrdersPageSize: 10,
      latestOrdersTotal: 0,
      configChartColumn: {
        data: [],
        isGroup: true,
        xField: 'month',
        yField: 'value',
        seriesField: 'category',
        appendPadding: 10,
        intervalPadding: 50,
        columnWidthRatio: 0.5,
        maxColumnWidth: 30,
        style: {
          inset: 1
        },
        color: ['#2F80ED', '#002555'],
        columnStyle: {
          dodgePadding: 10,
          columnWidthRatio: 0.5
        },
        label: {
          textBaseline: 'bottom',
          style: {
            rotate: -90,
            textAlign: 'center',
            textBaseline: 'middle'
          },
          layout: [
            {
              type: 'interval-adjust-position'
            }
          ]
        },
        yAxis: {
          max: 0
        }
      },
      configChartArea: {
        xField: 'month',
        yField: 'count',
        legend: {
          position: 'bottom',
          marginTop: 10
        },
        seriesField: 'category',
        color: ['#1979C9', '#FAA219', '#ff0066', '#000000'],
        xAxis: {
          range: [0, 1]
        }
      },
      selectedFilters: ['requestsReceived', 'quotationsSent', 'quotationsAccepted'],
      selectedPickupDeliveryFilter: 'byLocation',
      selectedOrdersQuotesCategories: ['requestsReceived', 'quotationsSent', 'quotationsAccepted'],
      showOQFilter: false,
      isOptionSelected: false,
      locationOptions: [],
      locationPage: 1,
      locationPageSize: 10,
      locationTotal: 0,
      locationLoadingMore: false,
      locationLoading: false,
      fullViewChart: null,
      fullViewModalVisible: false,
      fullViewModalWidth: '90vw',
      fullViewModalHeight: '90vh'
    };
    this.columns = this.buildColumns();
    this.timeoutId = null;
    this._revenueTrendCache = null;
    this._pickupDeliveryTrendCache = null;
    this.kpiRefs = [];
  }

  buildColumns(displayNames) {
    const names = displayNames || this.state?.fixedAttributeDisplayname || {};
    return [
      {
        title: (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.4150943)', fontWeight: 600 }}>
            {translate('orderID')}
          </span>
        ),
        dataIndex: 'order_id',
        align: 'left',
        key: 'order_id',
        onHeaderCell: () => ({ style: headerTextStyle }),
        render: (value) => (
          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 500 }}>{value}</span>
        )
      },
      {
        title: (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.4150943)', fontWeight: 600 }}>
            {translate('location')}
          </span>
        ),
        dataIndex: 'location',
        align: 'left',
        key: 'location',
        onHeaderCell: () => ({ style: headerTextStyle }),
        render: (text) => (
          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 500 }}>
            {text || ''}
          </span>
        )
      },
      {
        title: (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.4150943)', fontWeight: 600 }}>
            {names['order_name'] || translate('orderName')}
          </span>
        ),
        dataIndex: 'order_name',
        align: 'left',
        key: 'order_name',
        onHeaderCell: () => ({ style: headerTextStyle }),
        render: (_, row) => (
          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 500 }}>
            {row.order_name || ''}
          </span>
        )
      },
      {
        title: (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.4150943)', fontWeight: 600 }}>
            {translate('value')}
          </span>
        ),
        dataIndex: 'value',
        align: 'left',
        key: 'value',
        onHeaderCell: () => ({ style: headerTextStyle }),
        render: (val) => (
          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 500 }}>
            $ {Number(val).toFixed(2)}
          </span>
        )
      },
      {
        title: (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.4150943)', fontWeight: 600 }}>
            {translate('status')}
          </span>
        ),
        dataIndex: 'status',
        align: 'left',
        key: 'status',
        onHeaderCell: () => ({ style: headerTextStyle }),
        render: (__, row) => {
          const { label, bg, color } = getOrderStatusDisplay(row);
          return (
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                background: bg,
                color,
                padding: `var(--sp-xs) calc(var(--sp-md2)*1.132075)`,
                borderRadius: 'var(--sp-xxs)',
                fontSize: 'calc(var(--fs-xs)*1.132075)',
                fontWeight: 600,
                lineHeight: '100%',
                minHeight: 'calc(var(--fs-xl)*1.179245)'
              }}>
              {label}
            </div>
          );
        }
      },
      {
        title: (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.4150943)', fontWeight: 600 }}>
            {translate('date')}
          </span>
        ),
        dataIndex: 'created_at',
        align: 'left',
        key: 'created_at',
        onHeaderCell: () => ({ style: headerTextStyle }),
        render: (value) => (
          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 500 }}>
            {moment(value, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY - hh:mm a')}
          </span>
        )
      },
      {
        title: (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.4150943)', fontWeight: 600 }}>
            {translate('orderInfo')}
          </span>
        ),
        key: 'tags',
        dataIndex: 'tags',
        align: 'left',
        onHeaderCell: () => ({ style: headerTextStyle }),
        render: (__, row) => {
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
                color: '#1f2937 !important',
                borderRadius: 'var(--sp-xs)',
                width: 'calc(var(--fs-hero)*1.981132)',
                padding: 'var(--sp-xs) calc(var(--sp-md2)*1.415094)',
                cursor: 'pointer',
                boxShadow:
                  '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
                fontSize: 'calc(var(--fs-xs)*1.132075)',
                fontWeight: 600,
                border: '1.5px solid #d1d5db !important'
              }}
              onClick={() => {
                this.props?.navigate(`${ROUTER_NAME.orderDetail}/${row.order_id}`);
              }}>
              {translate('details')}
              <ArrowForwardIos
                className="icon"
                style={{
                  width: 'calc(var(--fs-xs)*1.132075)',
                  height: 'calc(var(--fs-xs)*1.132075)',
                  marginLeft: 'var(--sp-md2)'
                }}
              />
            </div>
          );
        }
      }
    ];
  }

  handleFullfilledBy = (row) => {
    const quote = row.quotes?.filter((q) => q.status === 'ACCEPTED');
    const pending = row.quotes?.find((q) => q.status === 'SENT');
    return quote.length > 0 ? quote?.[0]?.user?.name : pending?.id ? pending?.user?.name : 'N/A';
  };

  filterQuoteStatus = (status) => {
    switch (status) {
      case 'SENT':
        return 'Sent';
      case 'ACCEPTED':
        return 'Accepted';
      case 'NS':
        return 'Pending';
      default:
        return 'Pending';
    }
  };

  renderMonthSelect = () => {
    const months = [
      {
        month: translate('month.january'),
        value: 1
      },
      {
        month: translate('month.february'),
        value: 2
      },
      {
        month: translate('month.march'),
        value: 3
      },
      {
        month: translate('month.april'),
        value: 4
      },
      {
        month: translate('month.may'),
        value: 5
      },
      {
        month: translate('month.june'),
        value: 6
      },
      {
        month: translate('month.july'),
        value: 7
      },
      {
        month: translate('month.august'),
        value: 8
      },
      {
        month: translate('month.september'),
        value: 9
      },
      {
        month: translate('month.october'),
        value: 10
      },
      {
        month: translate('month.november'),
        value: 11
      },
      {
        month: translate('month.december'),
        value: 12
      }
    ];
    return months.map((e) => (
      <TextBase
        style={{
          paddingTop: 'calc(var(--sp-md2)*1.415094)',
          paddingBottom: 'calc(var(--sp-md2)*0.754717)'
        }}
        className="cursor-pointer"
        size="calc(var(--fs-xs)*1.32075)"
        color={Colors.black}
        onClick={() => {
          this.setState(
            {
              showOrdersMonthSelect: false,
              selectedMonth: moment()
                .month(e.value - 1)
                .format('MMMM')
            },
            () => {
              this.fetchOrders();
            }
          );
        }}>
        {e.month}
      </TextBase>
    ));
  };

  renderSpinnerComponent = () => {
    return (
      <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        {' '}
        <CustomSpinner />{' '}
      </div>
    );
  };

  openFullViewChart = (chartName) => {
    this.setState({ fullViewChart: chartName, fullViewModalVisible: true });
  };

  closeFullViewChart = () => {
    this.setState({ fullViewModalVisible: false, fullViewChart: null });
  };

  renderFullViewModal = () => {
    const { fullViewChart, fullViewModalVisible } = this.state;
    if (!fullViewModalVisible || !fullViewChart) return null;

    let chartComponent = null;
    const chartHeight = 'calc(90vh - 150px)';

    if (fullViewChart === 'revenueTrend' && this._revenueTrendCache) {
      chartComponent = <Line {...this._revenueTrendCache.config} style={{ height: chartHeight }} />;
    } else if (fullViewChart === 'pickupDeliveryTrend' && this._pickupDeliveryTrendCache) {
      chartComponent = (
        <Line {...this._pickupDeliveryTrendCache.config} style={{ height: chartHeight }} />
      );
    } else if (fullViewChart === 'revenueByLocation') {
      chartComponent = (
        <Column
          data={this.state.revenueByLocationData || []}
          xField="label"
          yField="value"
          seriesField={'label'}
          isGroup={false}
          legend={false}
          minColumnWidth={resolveCssVarValue('--fs-xs') * 1.6981132}
          maxColumnWidth={resolveCssVarValue('--fs-xs') * 3.2075471}
          columnStyle={(datum) => {
            const map = this._revenueByLocationColorMap || {};
            const baseColor = map[datum.label] || '#6366F1';
            return {
              radius: [resolveCssVarValue('--sp-xxs'), resolveCssVarValue('--sp-xxs'), 0, 0],
              shadowColor: 'rgba(0, 0, 0, 0.25)',
              shadowBlur: resolveCssVarValue('--sp-md2'),
              shadowOffsetX: resolveCssVarValue('--sp-md2') * 0.28301,
              shadowOffsetY: resolveCssVarValue('--sp-md2') * 0.471698,
              fill: `l(90) 0:${baseColor}99 1:${baseColor}`
            };
          }}
          color={(d) => {
            const map = this._revenueByLocationColorMap || {};
            return map[d.label] || '#6366F1';
          }}
          tooltip={{
            customContent: (title, items) => {
              if (!items || !items.length) return '';
              const it = items[0];
              return `<div style=\"padding:calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1.88679);font-size:calc(var(--fs-xs)*1.132075);\"><div style=\"font-weight:600;margin-bottom:calc(var(--sp-xxs)*1);\">${title}</div>
                        <div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>${
                          translate('revenue') || 'Revenue'
                        }</span><span style=\"font-weight:600;\">${
                it?.data?.value || 0
              }</span></div>
                      </div>`;
            }
          }}
          style={{ flex: 1, height: chartHeight }}
          xAxis={{
            label: {
              style: {
                fill: 'rgba(152, 152, 152, 1)',
                fontSize: resolveCssVarValue('--fs-xs') * 1.132075,
                fontWeight: 500
              },
              autoRotate: true,
              autoRotateAngle: -45,
              autoHide: true,
              formatter: (text) => {
                if (!text) return '';
                const MAX_LEN = 8;
                if (text.length > MAX_LEN) {
                  return text.slice(0, MAX_LEN - 1) + '…';
                }
                return text;
              }
            },
            line: {
              style: {
                stroke: 'rgba(235, 235, 235, 1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
              }
            },
            tickLine: null
          }}
          yAxis={{
            label: {
              style: {
                fill: 'rgba(152, 152, 152, 1)',
                fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                fontWeight: 500
              }
            },
            line: {
              style: {
                stroke: 'rgba(205, 213, 225, 1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
              }
            },
            grid: {
              line: {
                style: (text, index, items) => {
                  const lastIndex = items.length - 1;
                  if (index === 0 || index === lastIndex) return { lineWidth: 0 };
                  return {
                    stroke: 'rgba(230,230,230,1)',
                    lineWidth: resolveCssVarValue('--fs-xs') * 0.18867,
                    lineDash: [4, 4]
                  };
                }
              }
            }
          }}
          autoFit
          animation={false}
          meta={{ value: { min: 0 } }}
        />
      );
    } else if (fullViewChart === 'customerPreference') {
      chartComponent = (
        <Column
          data={this.state.customerPreferenceData || []}
          isGroup
          xField="period"
          style={{ flex: 1, height: chartHeight }}
          yField="value"
          seriesField="type"
          dodgePadding={resolveCssVarValue('--sp-md2') * 1.50943}
          minColumnWidth={resolveCssVarValue('--fs-hero') * 1.132075}
          maxColumnWidth={resolveCssVarValue('--fs-hero') * 1.32075}
          columnStyle={({ type }) => {
            const isPickup = type === 'Pickup';
            const topColor = isPickup ? 'rgba(160, 150, 235, 1)' : 'rgba(180, 190, 205, 1)';
            const bottomColor = isPickup ? 'rgba(120, 105, 200, 1)' : 'rgba(145, 155, 170, 1)';
            return {
              radius: [resolveCssVarValue('--sp-xxs'), resolveCssVarValue('--sp-xxs'), 0, 0],
              shadowColor: 'rgba(0, 0, 0, 0.25)',
              shadowBlur: resolveCssVarValue('--sp-md2'),
              shadowOffsetX: resolveCssVarValue('--sp-md2') * 0.28301,
              shadowOffsetY: resolveCssVarValue('--sp-md2') * 0.471698,
              fill: `l(90) 0:${topColor} 1:${bottomColor}`
            };
          }}
          tooltip={{
            customContent: (title, items) => {
              if (!items || !items.length) return '';
              const pickup = items.find((i) => i.data.type === 'Pickup');
              const delivery = items.find((i) => i.data.type === 'Delivery');
              return `<div style=\"padding:calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1.88679);font-size:calc(var(--fs-xs)*1.132075);\"><div style=\"font-weight:600;margin-bottom:calc(var(--sp-xxs)*1);\">${title}</div>
                        <div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>Pickup</span><span style=\"font-weight:600;\">${
                          pickup ? pickup.data.value : 0
                        }</span></div>
                        <div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>Delivery</span><span style=\"font-weight:600;\">${
                          delivery ? delivery.data.value : 0
                        }</span></div>
                      </div>`;
            }
          }}
          color={(d) => (d.type === 'Pickup' ? 'rgba(177, 169, 239, 1)' : 'rgba(193, 201, 210, 1)')}
          legend={false}
          xAxis={{
            label: {
              style: {
                fill: 'rgba(152, 152, 152, 1)',
                fontSize: resolveCssVarValue('--fs-xs') * 1.32075,
                fontWeight: 500
              },
              formatter: (t) => this.formatPeriodLabel(t)
            },
            line: {
              style: {
                stroke: 'rgba(235, 235, 235, 1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
              }
            },
            tickLine: null
          }}
          yAxis={{
            label: {
              style: {
                fill: 'rgba(152, 152, 152, 1)',
                fontSize: resolveCssVarValue('--fs-xs') * 1.32075,
                fontWeight: 500
              }
            },
            line: {
              style: {
                stroke: 'rgba(235, 235, 235, 1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
              }
            },
            grid: {
              line: {
                style: {
                  stroke: 'rgba(230,230,230,1)',
                  lineWidth: resolveCssVarValue('--fs-xs') * 0.09433,
                  lineDash: [4, 4]
                }
              }
            }
          }}
          autoFit
          animation={false}
          meta={{ value: { min: 0 } }}
        />
      );
    }

    return (
      <Modal
        width="90vw"
        centered={true}
        bodyStyle={{
          maxHeight: '85vh',
          overflow: 'hidden',
          padding: 'calc(var(--sp-md2)*2)',
          display: 'flex',
          flexDirection: 'column'
        }}
        title={
          <span style={{ fontWeight: 600, fontSize: 'calc(var(--fs-xs)*1.509433)' }}>
            {fullViewChart === 'revenueTrend'
              ? translate('revenueTrendOverTime')
              : fullViewChart === 'pickupDeliveryTrend'
              ? translate('dailyOrderTrend')
              : fullViewChart === 'revenueByLocation'
              ? translate('revenueByLocation')
              : fullViewChart === 'customerPreference'
              ? `${translate('customerPreference')} (${translate('pickupVsDelivery')})`
              : 'Full View'}
          </span>
        }
        visible={fullViewModalVisible}
        onCancel={this.closeFullViewChart}
        footer={null}
        closeIcon={
          <CloseIcon
            sx={{ fontSize: 'calc(var(--fs-sm)*2)', marginRight: 'calc(var(--sp-md2)*1.5)' }}
            onClick={() => {
              this.closeFullViewChart();
            }}
          />
        }
        destroyOnClose>
        <div style={{ flex: 1, minHeight: 0 }}>{chartComponent}</div>
      </Modal>
    );
  };

  _componentDidMount = () => {
    const saved = getSessionFilter('analytics', null);
    let startRange = this.state.selectedDateRange;
    let childId = this.state.selectedId;
    let pickupFilter = this.state.selectedPickupDeliveryFilter;
    if (saved) {
      try {
        if (
          saved.selectedDateRange &&
          Array.isArray(saved.selectedDateRange) &&
          saved.selectedDateRange.length === 2
        ) {
          startRange = [dayjs(saved.selectedDateRange[0]), dayjs(saved.selectedDateRange[1])];
        }
        if (saved.selectedId !== undefined) childId = saved.selectedId;
        if (saved.selectedPickupDeliveryFilter) pickupFilter = saved.selectedPickupDeliveryFilter;
        const restore = {};
        if (saved.selectedOrdersQuotesCategories)
          restore.selectedOrdersQuotesCategories = saved.selectedOrdersQuotesCategories;
        if (saved.latestOrdersPage) restore.latestOrdersPage = saved.latestOrdersPage;
        if (saved.latestOrdersPageSize) restore.latestOrdersPageSize = saved.latestOrdersPageSize;
        if (saved.textSearch) restore.textSearch = saved.textSearch;
        if (Object.keys(restore).length) this.setState(restore);
      } catch (e) {}
    }
    const initialH = this.computeChartHeight();
    this.setState({
      chartHeight: initialH,
      selectedDateRange: startRange,
      selectedId: childId,
      selectedPickupDeliveryFilter: pickupFilter
    });
    window.addEventListener('resize', this._handleResponsiveResize, { passive: true });
    this.fetchAcceptedOrders();
    this.fetchOrderSummary();
    this.fetchOrders();
    this.getFixedDisplayName();
    this.getAllVendorLocations();
    // this.fetchOrderList(this.state.selectedId);
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleResponsiveResize);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    if (this.kpiRefs) {
      this.kpiRefs.length = 0;
    }
    if (this._rafIds && Array.isArray(this._rafIds)) {
      this._rafIds.forEach((id) => cancelAnimationFrame(id));
      this._rafIds = [];
    }
  }

  computeChartHeight = () => {
    const vh = window.innerHeight || 0;
    const desired = Math.round(vh * 0.4);
    const MIN = resolveCssVarValue('--fs-hero') * 11.698113;
    const MAX = resolveCssVarValue('--fs-hero') * 12.26415;
    return Math.max(MIN, Math.min(desired, MAX));
  };

  formatPeriodLabel = (text) => {
    if (!text || typeof text !== 'string') return text;
    if (/^\d{4}$/.test(text)) return text;
    if (/^\d{4}-\d{2}$/.test(text)) {
      try {
        const [y, m] = text.split('-');
        const date = new Date(Number(y), Number(m) - 1, 1);
        const mon = date.toLocaleString('en-US', { month: 'short' });
        return `${mon} ${y}`;
      } catch (e) {
        return text;
      }
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
      try {
        const [y, m, d] = text.split('-');
        const date = new Date(Number(y), Number(m) - 1, Number(d));
        const day = String(date.getDate());
        const mon = date.toLocaleString('en-US', { month: 'short' });
        return `${day} ${mon}`;
      } catch (e) {
        return text;
      }
    }
    return text;
  };

  _handleResponsiveResize = () => {
    const h = this.computeChartHeight();
    if (h !== this.state.chartHeight) {
      this.setState({ chartHeight: h });
    }
    if (this._rafIds && Array.isArray(this._rafIds)) {
      this._rafIds.forEach((id) => cancelAnimationFrame(id));
    }
    this._rafIds = [];
    this.scheduleKpiMeasure();
  };

  measureKpiHeights = (cb) => {
    try {
      if (!this.kpiRefs || !this.kpiRefs.length) {
        cb && cb();
        return;
      }
      const heights = this.kpiRefs.map((r) =>
        r ? Math.ceil(r.getBoundingClientRect().height) : 0
      );
      if (!heights.length) {
        cb && cb();
        return;
      }
      const max = Math.max(...heights, 0);
      if (max && this.state.kpiCardHeight !== max) {
        this.setState({ kpiCardHeight: max }, () => cb && cb());
      } else {
        cb && cb();
      }
    } catch (e) {
      cb && cb();
    }
  };

  scheduleKpiMeasure = () => {
    if (this._rafIds && Array.isArray(this._rafIds)) {
      this._rafIds.forEach((id) => cancelAnimationFrame(id));
    }
    this._rafIds = [];
    this.setState({ kpiMeasuring: true }, () => {
      const first = requestAnimationFrame(() => {
        const second = requestAnimationFrame(() => {
          this.measureKpiHeights(() => {
            setTimeout(() => {
              this.measureKpiHeights(() => this.setState({ kpiMeasuring: false }));
            }, 0);
          });
        });
        this._rafIds.push(second);
      });
      this._rafIds.push(first);
    });
  };

  computeListType = (startDateStr, endDateStr) => {
    try {
      const start = new Date(startDateStr);
      const end = new Date(endDateStr);
      const diffMs = end.getTime() - start.getTime();
      const spanDays = Math.max(1, Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1);
      if (spanDays > 365) return 'year';
      if (spanDays > 30) return 'month';
      if (spanDays > 7) return 'week';
      return 'day';
    } catch (e) {
      return 'day';
    }
  };

  async fetchOrderList(id) {
    this.setState({
      loading: true
    });
    let query = {
      filter_type: this.state.filter,
      page: this.state.page,
      page_size: this.state.pageSize,
      ...(id && { child_account_id: id })
    };
    const resOrder = await APIManager.getInstance().getOrders(query);
    this.setState({
      orders: resOrder?.data?.data || [],
      loading: false,
      totalOrders: resOrder?.data?.page?.total_records || 0
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageSize !== this.state.pageSize ||
      prevState.filter !== this.state.filter
    ) {
      // Clear previous timeout if it exists
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      // Set new timeout for API call
      this.timeoutId = setTimeout(async () => {
        // this.fetchOrderList(this.state.selectedId);
      }, 0); // 300ms debounce delay
    }

    if (
      prevState.ordersSent !== this.state.ordersSent ||
      prevState.quotesSent !== this.state.quotesSent ||
      prevState.ordersAccepted !== this.state.ordersAccepted ||
      prevState.selectedOrdersQuotesCategories !== this.state.selectedOrdersQuotesCategories
    ) {
      this.updateOrdersQuotesData();
    }

    if (prevState.dashboardData !== this.state.dashboardData) {
      this.scheduleKpiMeasure();
    }

    try {
      const tracked = [
        'selectedDateRange',
        'selectedId',
        'selectedPickupDeliveryFilter',
        'selectedOrdersQuotesCategories',
        'latestOrdersPage',
        'latestOrdersPageSize',
        'textSearch'
      ];
      let changed = false;
      for (const k of tracked) {
        if (JSON.stringify(prevState[k]) !== JSON.stringify(this.state[k])) {
          changed = true;
          break;
        }
      }
      if (changed) {
        const sdr = this.state.selectedDateRange || [];
        setSessionFilter('analytics', {
          selectedDateRange: [sdr[0].format(dateFormat), sdr[1].format(dateFormat)],
          selectedId: this.state.selectedId,
          selectedPickupDeliveryFilter: this.state.selectedPickupDeliveryFilter,
          selectedOrdersQuotesCategories: this.state.selectedOrdersQuotesCategories,
          latestOrdersPage: this.state.latestOrdersPage,
          latestOrdersPageSize: this.state.latestOrdersPageSize,
          textSearch: this.state.textSearch
        });
      }
    } catch (e) {}
  }

  updateOrdersQuotesData = () => {
    const { selectedOrdersQuotesCategories, ordersSent, quotesSent, ordersAccepted } = this.state;
    if (!selectedOrdersQuotesCategories) return;
    const data = [];
    if (selectedOrdersQuotesCategories.includes('requestsReceived')) {
      data.push({
        category: translate('requestsReceived'),
        type: 'Orders',
        value: Number(ordersSent) || 0
      });
    }
    if (selectedOrdersQuotesCategories.includes('quotationsSent')) {
      data.push({
        category: translate('quotesSent'),
        type: 'Orders',
        value: Number(quotesSent) || 0
      });
    }
    if (selectedOrdersQuotesCategories.includes('quotationsAccepted')) {
      data.push({
        category: translate('quotesAccepted'),
        type: 'Orders',
        value: Number(ordersAccepted) || 0
      });
    }
    this.setState({ ordersQuotesData: data });
  };

  toggleOQCategory = (key) => {
    this.setState((prev) => {
      const order = ['requestsReceived', 'quotationsSent', 'quotationsAccepted'];
      let selected = [...prev.selectedOrdersQuotesCategories];
      if (selected.includes(key)) {
        if (selected.length === 1) return { selectedOrdersQuotesCategories: selected };
        selected = selected.filter((k) => k !== key);
      } else {
        selected.push(key);
      }
      selected = order.filter((o) => selected.includes(o));
      return { selectedOrdersQuotesCategories: selected };
    });
  };

  oqSelectedLabel = () => {
    const map = {
      requestsReceived: translate('requestsReceived'),
      quotationsSent: translate('quotesSent'),
      quotationsAccepted: translate('quotesAccepted')
    };
    const order = ['requestsReceived', 'quotationsSent', 'quotationsAccepted'];
    const sel = order.filter((k) => (this.state.selectedOrdersQuotesCategories || []).includes(k));
    if (sel.length === 0) return '';
    return sel.map((k) => map[k]).join(' vs ');
  };

  getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('en-US', { month: 'long' });
  }

  getCurrentYear = () => {
    const date = new Date();
    const currentYear = date.getFullYear();
    return currentYear;
  };

  fetchData = async () => {
    try {
      const { getAnalyticsCards, getAnalyticsCardsWithoutEndDate } = this.props;
      const accountParam = this.state.selectedId || undefined;
      let resp = '';
      if (
        this.state.selectedDateRange[0].format(dateFormat) ===
        this.state.selectedDateRange[1].format(dateFormat)
      ) {
        resp = await getAnalyticsCardsWithoutEndDate(
          accountParam,
          this.state.selectedDateRange[0].format(dateFormat)
        );
      } else {
        resp = await getAnalyticsCards(
          accountParam,
          this.state.selectedDateRange[0].format(dateFormat),
          this.state.selectedDateRange[1].format(dateFormat)
        );
      }
      const { data } = resp;
      const ordersSent = data?.order_received;
      const quotesSent = data?.quotes_sent;
      const locations = data?.child_account_count;
      const ordersAccepted = data?.orders_accepted;
      const value_of_accepted_quotes = data?.value_of_accepted_quotes;
      const percentage_change = data?.percentage_change;
      this.setState(
        {
          ordersSent: ordersSent || 0,
          ordersAccepted: ordersAccepted || 0,
          quotesSent: quotesSent || 0,
          locations: locations || 0,
          value_of_accepted_quotes: value_of_accepted_quotes || 0,
          percentage_change: percentage_change || null
        },
        () => {
          this.updateOrdersQuotesData();
        }
      );
    } catch (e) {}
  };

  fetchOrders = async (filter = 'yearly') => {
    try {
      this.setState({
        page: 1,
        filter: filter
      });
    } catch (e) {}
  };

  getMonthName = (month) => {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    return months[month - 1] || 'Invalid month';
  };

  fetchAcceptedOrders = async (filter = 'month') => {
    try {
      let result = [];
      const { getAcceptedOrders } = this.props;
      let resp = '';
      if (this.state.selectedId) {
        let child_account_id = this.state.selectedId;
        resp = await getAcceptedOrders({ child_account_id, filter });
      } else {
        resp = await getAcceptedOrders({ filter });
      }
      const data = resp?.data;

      data?.forEach((e, i) => {
        if (filter == 'month') {
          result.push({
            category: translate('quoteSent'),
            month: translate('month.' + this.getMonthName(e.month).toLowerCase()),
            value: e.quotes_sent
          });
        } else {
          result.push({
            category: translate('quoteSent'),
            year: e.year,
            value: e.quotes_sent
          });
        }
      });

      data?.forEach((e, i) => {
        if (filter == 'month') {
          result.push({
            category: translate('acceptedQuote'),
            month: translate('month.' + this.getMonthName(e.month).toLowerCase()),
            value: e.accepted_quotes
          });
        } else {
          result.push({
            category: translate('acceptedQuote'),
            year: e.year,
            value: e.accepted_quotes
          });
        }
      });
      const columnsChart = this.state.configChartColumn;
      let max = Math.max(...result.map((item) => item.value));
      columnsChart.yAxis.max = max + 10 ** (String(Math.floor(max)).length - 1);
      columnsChart.data = result;
      this.setState({
        configChartColumn: columnsChart
      });
    } catch (e) {}
  };

  fetchOrderSummary = async () => {
    this.setState({
      dataChartArea: []
    });
    try {
      const { getNumberOfQuotes } = this.props;

      let tempFilter = [...this.state.filters];

      let resp = '';
      let result = [];
      for (let i = 0; i < tempFilter.length; i++) {
        if (this.state.selectedId) {
          resp = await getNumberOfQuotes({
            year: this.getCurrentYear(),
            child_account_id: this.state.selectedId,
            group_by: this.state.filterOrdersCreated,
            filter: tempFilter[i],
            type: this.state.filterType == 'Numbers' ? 'numbers' : 'values'
          });
        } else {
          resp = await getNumberOfQuotes({
            year: this.getCurrentYear(),
            group_by: this.state.filterOrdersCreated,
            filter: tempFilter[i],
            type: this.state.filterType == 'Numbers' ? 'numbers' : 'values'
          });
        }
        const { data } = resp;

        if (this.state.filterOrdersCreated == 'monthly') {
          data?.summary?.map((item) => {
            if (tempFilter[i] == 'accepted_quotes') {
              result.push({
                count: item.accepted_quotes_value,
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('accpetedQuotes')
                    : translate('valueOfAcceptedQuotes')
              });
            } else if (tempFilter[i] == 'orders_accepted') {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersAccepted')
                    : translate('valueOfOrdersAccepted')
              });
            } else if (tempFilter[i] == 'orders_received') {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersReceived')
                    : translate('valueOfOrdersReceived')
              });
            } else {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('quotesSent')
                    : translate('valueOfQuotesSent')
              });
            }
          });
        } else {
          data?.summary?.map((item) => {
            if (tempFilter[i] == 'accepted_quotes') {
              result.push({
                count: item.accepted_quotes_value,
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('accpetedQuotes')
                    : translate('valueOfAcceptedQuotes')
              });
            } else if (tempFilter[i] == 'orders_accepted') {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersAccepted')
                    : translate('valueOfOrdersAccepted')
              });
            } else if (tempFilter[i] == 'orders_received') {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersReceived')
                    : translate('valueOfOrdersReceived')
              });
            } else {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('quotesSent')
                    : translate('valueOfQuotesSent')
              });
            }
          });
        }
      }

      this.setState({
        dataChartArea: result || []
      });
    } catch (e) {}
  };

  handleDateChange = async (dates) => {
    if (!dates || (Array.isArray(dates) && dates.length === 0)) {
      // Perform your tasks when the range is cleared

      const today = dayjs();
      const twoWeekAgo = dayjs().subtract(13, 'day');
      this.setState({
        selectedDateRange: [twoWeekAgo, today]
      });
    } else {
      this.setState({
        selectedDateRange: dates,
        latestOrdersPage: 1
      });

      try {
        const start = dates[0].format('YYYY-MM-DD');
        const end = dates[1].format('YYYY-MM-DD');
        const childId = this.state.selectedId;
        this.getDashboardData(start, end, childId);
        if (this.state.selectedPickupDeliveryFilter === 'dailyOrderTrend') {
          this.getPickupDeliveryByLocation(start, end, childId, true);
        } else {
          this.getPickupDeliveryByLocation(start, end, childId);
        }
        this.getRevenueTrendData(start, end, childId);
        this.getRevenueByOrderTypeData(start, end, childId);
        this.getRevenueByLocationData(start, end, childId);
        this.getNewRepeatCustomersData(start, end, childId);
        this.getCustomerPreferenceData(start, end, childId);
        this.getPendingOrderByLocation(start, end, childId);
        this.getLatestOrders(start, end, childId);
      } catch (e) {}
    }
  };

  radioChange = async (index, value) => {
    const prevRadio = [...this.state.radios];
    prevRadio.map((item) => {
      item.selected = false;
    });
    prevRadio[index].selected = true;
    this.setState({
      radios: prevRadio
    });

    try {
      const { getNumberOfQuotes } = this.props;
      let result = [];
      let tempFilter = [...this.state.filters];
      let resp = '';
      for (let i = 0; i < tempFilter.length; i++) {
        if (this.state.selectedId) {
          resp = await getNumberOfQuotes({
            year: this.getCurrentYear(),
            child_account_id: this.state.selectedId,
            group_by: this.state.filterOrdersCreated,
            filter: tempFilter[i],
            type: value == 'Numbers' ? 'numbers' : 'values'
          });
        } else {
          resp = await getNumberOfQuotes({
            year: this.getCurrentYear(),
            group_by: this.state.filterOrdersCreated,
            filter: tempFilter[i],
            type: value == 'Numbers' ? 'numbers' : 'values'
          });
        }

        const { data } = resp;

        if (this.state.filterOrdersCreated == 'monthly') {
          data?.summary?.map((item) => {
            if (tempFilter[i] == 'accepted_quotes') {
              result.push({
                count: item.accepted_quotes_value,
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  value == 'Numbers'
                    ? translate('accpetedQuotes')
                    : translate('valueOfAcceptedQuotes')
              });
            } else if (tempFilter[i] == 'orders_accepted') {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  value == 'Numbers'
                    ? translate('ordersAccepted')
                    : translate('valueOfOrdersAccepted')
              });
            } else if (tempFilter[i] == 'orders_received') {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  value == 'Numbers'
                    ? translate('ordersReceived')
                    : translate('valueOfOrdersReceived')
              });
            } else {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  value == 'Numbers' ? translate('quotesSent') : translate('valueOfQuotesSent')
              });
            }
          });
        } else {
          data?.summary?.map((item) => {
            if (tempFilter[i] == 'accepted_quotes') {
              result.push({
                count: item.accepted_quotes_value,
                year: item.year,
                category:
                  value == 'Numbers'
                    ? translate('accpetedQuotes')
                    : translate('valueOfAcceptedQuotes')
              });
            } else if (tempFilter[i] == 'orders_accepted') {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  value == 'Numbers'
                    ? translate('ordersAccepted')
                    : translate('valueOfOrdersAccepted')
              });
            } else if (tempFilter[i] == 'orders_received') {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  value == 'Numbers'
                    ? translate('ordersReceived')
                    : translate('valueOfOrdersReceived')
              });
            } else {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  value == 'Numbers' ? translate('quotesSent') : translate('valueOfQuotesSent')
              });
            }
          });
        }
      }
      this.setState({
        filterType: value,
        dataChartArea: result || []
      });
    } catch (e) {}
  };

  handleMenuClick = (e) => {};

  handleCheckboxChange = async (e, itemName) => {
    try {
      const { getNumberOfQuotes } = this.props;
      let result = [];
      let tempFilter = [...this.state.filters];
      if (tempFilter.includes(itemName)) {
        if (itemName != 'orders_received') {
          const index = tempFilter.indexOf(itemName);
          if (index !== -1) {
            tempFilter.splice(index, 1);
          }
        }
      } else {
        tempFilter.push(itemName);
      }

      let resp = '';
      for (let i = 0; i < tempFilter.length; i++) {
        if (this.state.selectedId) {
          resp = await getNumberOfQuotes({
            year: this.getCurrentYear(),
            child_account_id: this.state.selectedId,
            group_by: this.state.filterOrdersCreated,
            filter: tempFilter[i],
            type: this.state.filterType == 'Numbers' ? 'numbers' : 'values'
          });
        } else {
          resp = await getNumberOfQuotes({
            year: this.getCurrentYear(),
            group_by: this.state.filterOrdersCreated,
            filter: tempFilter[i],
            type: this.state.filterType == 'Numbers' ? 'numbers' : 'values'
          });
        }
        const { data } = resp;

        if (this.state.filterOrdersCreated == 'monthly') {
          data?.summary?.map((item) => {
            if (tempFilter[i] == 'accepted_quotes') {
              result.push({
                count: item.accepted_quotes_value,
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('accpetedQuotes')
                    : translate('valueOfAcceptedQuotes')
              });
            } else if (tempFilter[i] == 'orders_accepted') {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersAccepted')
                    : translate('valueOfOrdersAccepted')
              });
            } else if (tempFilter[i] == 'orders_received') {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersReceived')
                    : translate('valueOfOrdersReceived')
              });
            } else {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('quotesSent')
                    : translate('valueOfQuotesSent')
              });
            }
          });
        } else {
          data?.summary?.map((item) => {
            if (tempFilter[i] == 'accepted_quotes') {
              result.push({
                count: item.accepted_quotes_value,
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('accpetedQuotes')
                    : translate('valueOfAcceptedQuotes')
              });
            } else if (tempFilter[i] == 'orders_accepted') {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersAccepted')
                    : translate('valueOfOrdersAccepted')
              });
            } else if (tempFilter[i] == 'orders_received') {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersReceived')
                    : translate('valueOfOrdersReceived')
              });
            } else {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('quotesSent')
                    : translate('valueOfQuotesSent')
              });
            }
          });
        }
      }

      this.setState({
        filters: tempFilter,
        dataChartArea: result || []
      });
    } catch (e) {}
  };

  handleMonthYearChangeLineGraph = async (value) => {
    try {
      const { getNumberOfQuotes } = this.props;
      let result = [];
      let tempFilter = [...this.state.filters];
      for (let i = 0; i < tempFilter.length; i++) {
        let resp = '';
        if (this.state.selectedId) {
          resp = await getNumberOfQuotes({
            year: this.getCurrentYear(),
            child_account_id: this.state.selectedId,
            group_by: value,
            filter: tempFilter[i],
            type: this.state.filterType == 'Numbers' ? 'numbers' : 'values'
          });
        } else {
          resp = await getNumberOfQuotes({
            year: this.getCurrentYear(),
            group_by: value,
            filter: tempFilter[i],
            type: this.state.filterType == 'Numbers' ? 'numbers' : 'values'
          });
        }
        const { data } = resp;

        if (value == 'monthly') {
          data?.summary?.map((item) => {
            if (tempFilter[i] == 'accepted_quotes') {
              result.push({
                count: item.accepted_quotes_value,
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('accpetedQuotes')
                    : translate('valueOfAcceptedQuotes')
              });
            } else if (tempFilter[i] == 'orders_accepted') {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersAccepted')
                    : translate('valueOfOrdersAccepted')
              });
            } else if (tempFilter[i] == 'orders_received') {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersReceived')
                    : translate('valueOfOrdersReceived')
              });
            } else {
              result.push({
                count: item[tempFilter[i]],
                month: translate('month.' + item.month.toLowerCase()),
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('quotesSent')
                    : translate('valueOfQuotesSent')
              });
            }
          });
        } else {
          data?.summary?.map((item) => {
            if (tempFilter[i] == 'accepted_quotes') {
              result.push({
                count: item.accepted_quotes_value,
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('accpetedQuotes')
                    : translate('valueOfAcceptedQuotes')
              });
            } else if (tempFilter[i] == 'orders_accepted') {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersAccepted')
                    : translate('valueOfOrdersAccepted')
              });
            } else if (tempFilter[i] == 'orders_received') {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('ordersReceived')
                    : translate('valueOfOrdersReceived')
              });
            } else {
              result.push({
                count: item[tempFilter[i]],
                year: item.year,
                category:
                  this.state.filterType == 'Numbers'
                    ? translate('quotesSent')
                    : translate('valueOfQuotesSent')
              });
            }
          });
        }
      }

      this.setState({
        dataChartArea: result || []
      });
    } catch (e) {}
  };

  filterNames = () => {
    let value = '';
    if (this.state.filterType == 'Numbers') {
      if (this.state.filters.length == 1 && this.state.filters[0] == 'orders_received') {
        value = translate('choose');
        return value;
      } else {
        this.state.filters.map((item) => {
          if (item == 'accepted_quotes') {
            value = value + translate('vsAcceptedQuotes');
          } else if (item == 'orders_accepted') {
            value = value + translate('vsOrdersAccepted');
          } else if (item == 'orders_received') {
            value = value + translate('vsOrdersReceived');
          } else {
            value = value + translate('vsQuotesSent');
          }
        });
        return value.substring(4);
      }
    } else {
      if (this.state.filters.length == 1 && this.state.filters[0] == 'orders_received') {
        value = translate('choose');
        return value;
      } else {
        this.state.filters.map((item) => {
          if (item == 'accepted_quotes') {
            value = value + translate('vsValueOfAcceptedQuotes');
          } else if (item == 'orders_accepted') {
            value = value + translate('vsValueOfOrdersAccepted');
          } else if (item == 'orders_received') {
            value = value + translate('vsValueOfOrdersReceived');
          } else {
            value = value + translate('vsValueOfQuotesSent');
          }
        });
        return value.substring(4);
      }
    }
  };

  checkDateisToday = () => {
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0]; // Format YYYY-MM-DD
    if (
      this.state.selectedDateRange[0].format(dateFormat) === todayStr &&
      this.state.selectedDateRange[1].format(dateFormat) === todayStr
    ) {
      return true;
    } else {
      return false;
    }
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      page: pagination.current,
      pageSize: pagination.pageSize
    });
  };

  // Load all dashboard data for selected location or all locations
  loadAllDashboardData = (childId = undefined) => {
    const start = this.state.selectedDateRange[0].format('YYYY-MM-DD');
    const end = this.state.selectedDateRange[1].format('YYYY-MM-DD');

    this.getDashboardData(start, end, childId);
    if (this.state.selectedPickupDeliveryFilter === 'dailyOrderTrend') {
      this.getPickupDeliveryByLocation(start, end, childId, true);
    } else {
      this.getPickupDeliveryByLocation(start, end, childId);
    }
    this.getRevenueTrendData(start, end, childId);
    this.getRevenueByOrderTypeData(start, end, childId);
    this.getRevenueByLocationData(start, end, childId);
    this.getNewRepeatCustomersData(start, end, childId);
    this.getCustomerPreferenceData(start, end, childId);
    this.getPendingOrderByLocation(start, end, childId);
    this.getLatestOrders(start, end, childId);
  };

  getAllVendorLocations(page = 1, append = false) {
    const { locationPageSize } = this.state;
    // Only show loading indicator for scroll pagination, not initial load
    if (append) {
      this.setState({ locationLoadingMore: true });
    } else {
      this.setState({ locationLoading: true });
    }

    Utils.api.getApiCall(
      `analytics/vendors/?page=${page}&page_size=${locationPageSize}`,
      '',
      (resp) => {
        try {
          // Handle response wrapping - API might return response directly or wrapped
          let locationData = [];
          let pageInfo = {};

          // Check if response has data and page properties
          if (resp && typeof resp === 'object') {
            if (Array.isArray(resp.data)) {
              // Response structure: { data: [...], page: {...} }
              locationData = resp.data;
              pageInfo = resp.page || {};
            } else if (
              resp.data &&
              typeof resp.data === 'object' &&
              Array.isArray(resp.data.data)
            ) {
              // Response structure: { data: { data: [...], page: {...} } }
              locationData = resp.data.data;
              pageInfo = resp.data.page || {};
            }
          }
          const capitalizeWords = (str) => {
            return str.replace(/\b\w/g, (char) => char.toUpperCase());
          };

          const newOptions = (locationData || []).map((d) => ({
            value: d.id,
            label: capitalizeWords(d.business_name)
          }));

          // Add "All Locations" option at the beginning on initial load only
          if (!append && newOptions.length > 0) {
            newOptions.unshift({ value: '', label: 'All Locations' });
          }

          // On initial load, auto-select "All Locations" and trigger data fetch
          const defaultSelectedId = !append && newOptions.length > 0 ? '' : this.state.selectedId;

          this.setState(
            {
              locationOptions: append ? [...this.state.locationOptions, ...newOptions] : newOptions,
              locationPage: page,
              locationTotal: pageInfo?.total_records || 0,
              locationLoadingMore: false,
              locationLoading: false,
              selectedId: defaultSelectedId
            },
            () => {
              // Auto-load all dashboard data on initial load
              if (!append) {
                this.loadAllDashboardData(defaultSelectedId || undefined);
              }
            }
          );
        } catch (parseError) {
          console.error('Error parsing location response:', parseError, 'Response:', resp);
          this.setState({ locationLoadingMore: false, locationLoading: false });
          Utils.showAlert(2, 'Failed to parse location data');
        }
      },
      (error) => {
        console.error('Error fetching locations:', error);
        this.setState({ locationLoadingMore: false, locationLoading: false });
        Utils.showAlert(2, error?.detail || error?.message || 'Failed to load locations');
      }
    );
  }

  handleLocationChange = (value) => {
    this.setState(
      {
        selectedId: value,
        latestOrdersPage: 1,
        isOptionSelected: true
      },
      () => {
        // Load all dashboard data - pass undefined for "All Locations"
        this.loadAllDashboardData(value || undefined);
      }
    );
  };

  handleLocationScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50;
    const { locationPage, locationPageSize, locationTotal, locationLoadingMore } = this.state;
    const totalPages = Math.ceil(locationTotal / locationPageSize);

    if (isNearBottom && locationPage < totalPages && !locationLoadingMore) {
      this.getAllVendorLocations(locationPage + 1, true);
    }
  };

  getDashboardData(start_date, end_date, vendor_ids) {
    const dataToSend = { start_date, end_date };
    if (vendor_ids) dataToSend.vendor_ids = vendor_ids;
    const result = buildQueryString(dataToSend);
    this.setState({ kpiLoading: true });
    Utils.api.getApiCall(
      'analytics/kpi/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        const ordersSent = Number(data?.order_received || 0);
        const quotesSent = Number(data?.quote_sent || 0);
        const quoteAccepted = Number(data?.quote_accepted || 0);

        const selected = this.state.selectedOrdersQuotesCategories || [];
        const oqData = [];
        if (selected.includes('requestsReceived')) {
          oqData.push({
            category: translate('requestsReceived'),
            type: 'Orders',
            value: ordersSent
          });
        }
        if (selected.includes('quotationsSent')) {
          oqData.push({ category: translate('quotesSent'), type: 'Orders', value: quotesSent });
        }
        if (selected.includes('quotationsAccepted')) {
          oqData.push({
            category: translate('quotesAccepted'),
            type: 'Orders',
            value: quoteAccepted
          });
        }

        this.setState(
          {
            dashboardData: data,
            ordersSent,
            quotesSent,
            ordersAccepted: quoteAccepted,
            ordersQuotesData: oqData,
            kpiLoading: false
          },
          () => {
            requestAnimationFrame(() => {
              this.measureKpiHeights && this.measureKpiHeights();
              requestAnimationFrame(() => this.measureKpiHeights && this.measureKpiHeights());
              setTimeout(() => this.measureKpiHeights && this.measureKpiHeights(), 80);
            });
          }
        );
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ kpiLoading: false });
      }
    );
  }
  getPickupDeliveryByLocation(start_date, end_date, child_account_id, trend = false) {
    const dataToSend = { start_date, end_date };
    this.setState({ pickupDeliveryLoading: true });
    if (child_account_id) dataToSend.vendor_ids = child_account_id;
    if (trend) {
      dataToSend.trend = true;
      try {
        const listType = this.computeListType(start_date, end_date);
        dataToSend.list_type = listType;
      } catch (e) {
        /* silent fallback */
      }
    }
    const result = buildQueryString(dataToSend);
    Utils.api.getApiCall(
      'analytics/delivery-type/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        if (trend) {
          const trendData = (data || [])
            .filter((d) => d && d.period)
            .map((d) => ({
              period: d.period,
              Pickup: Number(d.pickup_count || 0),
              Delivery: Number(d.delivery_count || 0)
            }))
            .sort((a, b) => new Date(a.period) - new Date(b.period));
          this.setState({ pickupDeliveryTrendData: trendData, pickupDeliveryLoading: false });
        } else {
          const transformed = [];
          (data || []).forEach((item) => {
            const city = item.business_name || 'Unknown';
            const pickup = Number(item.pickup_count || 0);
            const delivery = Number(item.delivery_count || 0);
            transformed.push({ location: `${city}`, type: 'Pickup', value: pickup });
            transformed.push({ location: `${city}`, type: 'Delivery', value: delivery });
          });
          this.setState({ pickupDeliveryData: transformed, pickupDeliveryLoading: false });
        }
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ pickupDeliveryLoading: false });
      }
    );
  }
  getRevenueTrendData(start_date, end_date, child_account_id) {
    const dataToSend = { start_date, end_date };
    const listType = this.computeListType(start_date, end_date);
    dataToSend.list_type = listType;
    if (child_account_id) dataToSend.vendor_ids = child_account_id;
    const result = buildQueryString(dataToSend);
    this.setState({ revenueTrendLoading: true });
    Utils.api.getApiCall(
      'analytics/revenue-trend/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        const cleaned = (data || [])
          .filter((d) => d && d.period && typeof d.total_revenue !== 'undefined')
          .map((d) => ({ period: d.period, value: Number(d.total_revenue) || 0 }))
          .sort((a, b) => new Date(a.period) - new Date(b.period));
        const INJECT_TEST_REVENUE = false;
        let augmented = cleaned;
        if (INJECT_TEST_REVENUE && cleaned.length > 0) {
          const lastDate = new Date(cleaned[cleaned.length - 1].period);
          for (let i = 1; i <= 10; i++) {
            const d = new Date(lastDate);
            d.setDate(d.getDate() + i);
            const iso = d.toISOString().split('T')[0];
            const base = 50000 + Math.round(Math.random() * 45000);
            augmented.push({ period: iso, value: base });
          }
          const currentMax = Math.max(...cleaned.map((c) => c.value));
          if (currentMax < 10000) {
            augmented = augmented.map((p) => ({
              ...p,
              value: Math.round(p.value * (4 + Math.random()))
            }));
          }
        }
        augmented.sort((a, b) => new Date(a.period) - new Date(b.period));
        this.setState({ revenueTrendData: augmented, revenueTrendLoading: false });
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ revenueTrendLoading: false });
      }
    );
  }
  getRevenueByOrderTypeData(start_date, end_date, child_account_id) {
    const dataToSend = { start_date, end_date };
    const listType = this.computeListType(start_date, end_date);
    dataToSend.list_type = listType;
    if (child_account_id) dataToSend.vendor_ids = child_account_id;
    const result = buildQueryString(dataToSend);
    this.setState({ revenueByOrderTypeLoading: true });
    Utils.api.getApiCall(
      'analytics/delivery-revenue/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        const transformed = [];
        (data || []).forEach((item) => {
          const period = item.period;
          const pickup = Number(item.pickup_revenue || 0);
          const delivery = Number(item.delivery_revenue || 0);
          transformed.push({ period, type: 'Pickup', value: pickup });
          transformed.push({ period, type: 'Delivery', value: delivery });
        });
        this.setState({ revenueByOrderTypeData: transformed, revenueByOrderTypeLoading: false });
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ revenueByOrderTypeLoading: false });
      }
    );
  }

  getRevenueByLocationData(start_date, end_date, child_account_id) {
    const dataToSend = { start_date, end_date };
    if (child_account_id) dataToSend.vendor_ids = child_account_id;
    const result = buildQueryString(dataToSend);
    this.setState({ revenueByLocationLoading: true });
    Utils.api.getApiCall(
      'analytics/location-revenue/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        const transformed = [];
        const colorMap = {};
        const palette = [
          'rgba(126, 238, 130, 1)',
          'rgba(177, 169, 239, 1)',
          'rgba(223, 168, 119, 1)',
          'rgba(99, 102, 241, 1)',
          'rgba(139, 92, 246, 1)',
          'rgba(236, 72, 153, 1)',
          'rgba(245, 158, 11, 1)',
          'rgba(16, 185, 129, 1)',
          'rgba(14, 165, 233, 1)',
          'rgba(244, 63, 94, 1)',
          'rgba(132, 204, 22, 1)',
          'rgba(249, 115, 22, 1)',
          'rgba(20, 184, 166, 1)',
          '#64748B',
          '#78716C',
          '#9333EA',
          '#E11D48',
          '#059669',
          '#2563EB'
        ];
        (data || []).forEach((item, index) => {
          const labelBase =
            item.vendor_business_name && item.vendor_business_name.trim() !== ''
              ? item.vendor_business_name.trim()
              : `Unknown ${index + 1}`;
          const locationKey = `${labelBase}+${index + 1}`;
          const revenue = Number(item.total_revenue || 0);
          transformed.push({ location: locationKey, label: labelBase, value: revenue });
          colorMap[labelBase] = palette[index % palette.length];
        });
        this._revenueByLocationColorMap = colorMap;
        this.setState({ revenueByLocationData: transformed, revenueByLocationLoading: false });
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ revenueByLocationLoading: false });
      }
    );
  }
  getNewRepeatCustomersData(start_date, end_date, child_account_id) {
    const dataToSend = { start_date, end_date };
    if (child_account_id) dataToSend.vendor_ids = child_account_id;
    const result = buildQueryString(dataToSend);
    this.setState({ newRepeatCustomersLoading: true });
    Utils.api.getApiCall(
      'analytics/customer/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        const newCustomers = Number(data?.new_customers || 0);
        const repeatPct = Number(data?.repeat_customer_percentage || 0);
        const pieData = [
          { type: translate('repeatCustomers') || 'Repeat Customers', value: repeatPct },
          { type: translate('newCustomers') || 'New Customers', value: newCustomers }
        ];
        this.setState({ newRepeatCustomersPie: pieData, newRepeatCustomersLoading: false });
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ newRepeatCustomersLoading: false });
      }
    );
  }
  getCustomerPreferenceData(start_date, end_date, child_account_id) {
    const dataToSend = { start_date, end_date };
    if (child_account_id) dataToSend.vendor_ids = child_account_id;
    const listType = this.computeListType(start_date, end_date);
    dataToSend.list_type = listType;
    const result = buildQueryString(dataToSend);
    this.setState({ customerPreferenceLoading: true });
    Utils.api.getApiCall(
      'analytics/order-delivery/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        const transformed = [];
        (data || []).forEach((item) => {
          const period = item.period;
          const pickup = Number(item.pickup_count || 0);
          const delivery = Number(item.delivery_count || 0);
          transformed.push({ period, type: 'Pickup', value: pickup });
          transformed.push({ period, type: 'Delivery', value: delivery });
        });
        this.setState({ customerPreferenceData: transformed, customerPreferenceLoading: false });
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ customerPreferenceLoading: false });
      }
    );
  }
  getPendingOrderByLocation(start_date, end_date, child_account_id) {
    const dataToSend = { start_date, end_date };
    if (child_account_id) dataToSend.vendor_ids = child_account_id;
    const result = buildQueryString(dataToSend);
    this.setState({ pendingOrdersLoading: true });
    Utils.api.getApiCall(
      'analytics/location-pending-orders/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        this.setState({ pendingOrdersData: data, pendingOrdersLoading: false });
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ pendingOrdersLoading: false });
      }
    );
  }
  getLatestOrders(
    start_date,
    end_date,
    child_account_id,
    latestOrdersPage = this.state.latestOrdersPage,
    latestOrdersPageSize = this.state.latestOrdersPageSize
  ) {
    const dataToSend = {
      start_date,
      end_date,
      page: latestOrdersPage,
      page_size: latestOrdersPageSize
    };
    if (child_account_id) dataToSend.vendor_ids = child_account_id;
    const result = buildQueryString(dataToSend);
    this.setState({ latestOrdersLoading: true });
    Utils.api.getApiCall(
      'analytics/orders/',
      `?${result}`,
      (respData) => {
        const { data } = respData;
        const results = data?.results || [];
        const total = data?.page?.total_records || data?.count || results.length || 0;
        this.setState({ orders: results, latestOrdersTotal: total, latestOrdersLoading: false });
      },
      (error) => {
        Utils.showAlert(2, error.detail || error.message);
        this.setState({ latestOrdersLoading: false });
      }
    );
  }

  getFixedDisplayName = async () => {
    try {
      const names = await fetchFixedAttributeDisplayNames();
      this.setState({ fixedAttributeDisplayname: names }, () => {
        this.columns = this.buildColumns(names);
        this.forceUpdate();
      });
    } catch (e) {}
  };

  handleLatestOrdersPageChange = (page, pageSize) => {
    this.setState({ latestOrdersPage: page, latestOrdersPageSize: pageSize }, () => {
      const start = this.state.selectedDateRange[0].format('YYYY-MM-DD');
      const end = this.state.selectedDateRange[1].format('YYYY-MM-DD');
      const childId = this.state.selectedId;
      this.getLatestOrders(start, end, childId);
    });
  };
  renderContent() {
    const {
      dataChartArea,
      ordersSent,
      ordersAccepted,
      quotesSent,
      showFilterOrder,
      filterOrdersCreated,
      filterOrdersCreatedBar,
      selectedMonth,
      showOrdersMonthSelect,
      textSearch,
      selectedDateRange,
      radios,
      locations,
      percentage_change,
      filterOrders,
      revenueTrendData
    } = this.state;
    const ordersQuotesMax = Math.max(
      ...(this.state.ordersQuotesData || []).map((d) => d?.value || 0),
      0
    );
    if (
      !this._ordersQuotesCache ||
      this._ordersQuotesCache.data !== this.state.ordersQuotesData ||
      this._ordersQuotesCache.max !== ordersQuotesMax ||
      this._ordersQuotesCache.chartHeight !== this.state.chartHeight
    ) {
      const rawMax = ordersQuotesMax || 0;
      const chooseStep = (m) => {
        if (m <= 50) return 10;
        if (m <= 100) return 15;
        if (m <= 200) return 20;
        if (m <= 500) return 50;
        if (m <= 1000) return 100;
        if (m <= 2000) return 200;
        if (m <= 5000) return 500;
        if (m <= 10000) return 1500;
        if (m <= 20000) return 2000;
        return 4000;
      };
      const step = chooseStep(rawMax);
      let baseSnappedMax = Math.ceil((rawMax || 0) / step) * step;
      if (baseSnappedMax === 0) baseSnappedMax = step;
      const axisMax = baseSnappedMax + 2 * step;
      const smallCard = (this.state.chartHeight || 0) < resolveCssVarValue('--fs-hero') * 8.49056;
      const annotationY = baseSnappedMax + Math.round(0.6 * step);
      const htmlAnnotations = (this.state.ordersQuotesData || []).map((d) => ({
        type: 'html',
        position: [d.category, annotationY * 1.26],
        html: () =>
          `<div style=\"color:#0F172A;white-space:wrap; display:flex; flex-direction:column; align-items:flex-start; transform: translate(-50%, -40%);width:70%\">\n<p style=\"font-size:calc(var(--fs-xs)*1.2264);font-weight:400;margin-bottom:var(--sp-sm)\">${d.category}</p>\n<p style=\"font-size:calc(var(--fs-xs)*1.886);font-weight:500\">${d.value}</p>\n</div>`
      }));
      const categories = (this.state.ordersQuotesData || []).map((d) => d.category);
      const boundaryLines = [];
      if (categories.length > 1) {
        const n = categories.length;
        for (let i = 1; i < n; i++) {
          const pct = (i / n) * 100;
          boundaryLines.push({
            type: 'line',
            start: [`${pct}%`, '0%'],
            end: [`${pct}%`, '100%'],
            style: {
              stroke: 'rgba(235, 235, 235, 1)',
              lineDash: [2, 0],
              lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
            }
          });
        }
      }
      const annotations = [...htmlAnnotations, ...boundaryLines];
      const xAxis = {
        line: {
          style: {
            stroke: 'rgba(235, 235, 235, 1)',
            lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
          }
        },
        tickLine: null,
        label: null,
        title: null,
        grid: null
      };
      const yAxis = {
        max: axisMax,
        tickInterval: step,
        line: {
          style: {
            stroke: 'rgba(235, 235, 235, 1)',
            lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
          }
        },
        grid: {
          line: {
            style: (text, index, items) => {
              const lastIndex = items.length - 1;
              if (index === 0 || index === lastIndex || index === lastIndex - 1)
                return { lineWidth: 0 };
              return {
                stroke: 'rgba(230,230,230,1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.18867,
                lineDash: [4, 4]
              };
            }
          }
        },
        tickLine: null,
        label: {
          style: {
            fill: 'rgba(152, 152, 152, 1)',
            fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
            fontWeight: 500
          },
          formatter: (text) => {
            const v = Number(text);
            if (!isNaN(v) && v >= baseSnappedMax + step) return '';
            return text;
          }
        }
      };
      const tooltip = {
        customContent: (title, items) => {
          if (!items || items.length === 0) return null;
          const total = items.reduce((acc, i) => acc + Number(i.data?.value || 0), 0);
          return (
            <div
              style={{
                padding: 'calc(var(--sp-xxs)*2) calc(var(--sp-md)*1)',
                fontSize: resolveCssVarValue('--fs-xs') * 1.132075
              }}>
              {items.map((i) => (
                <div
                  key={i.data.category}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 'calc(var(--sp-xxs)*2)'
                  }}>
                  <span>{i.data.category} :</span>
                  <span style={{ fontWeight: 600 }}>{i.data.value}</span>
                </div>
              ))}
            </div>
          );
        }
      };
      const styleObj = { flex: 1, height: '100%' };
      const columnStyle = () => ({
        radius: [resolveCssVarValue('--sp-xxs'), resolveCssVarValue('--sp-xxs'), 0, 0],

        shadowColor: 'rgba(0, 0, 0, 0.25)',
        shadowBlur: resolveCssVarValue('--sp-md2'),
        shadowOffsetX: resolveCssVarValue('--sp-md2') * 0.28301,
        shadowOffsetY: resolveCssVarValue('--sp-md2') * 0.471698,

        fill: 'l(90) 0:rgba(56, 135, 253, 1) 1:rgba(50, 100, 200, 1)'
      });

      this._ordersQuotesCache = {
        data: this.state.ordersQuotesData,
        max: ordersQuotesMax,
        chartHeight: this.state.chartHeight,
        meta: { value: { min: 0, max: axisMax } },
        annotations,
        config: {
          data: this.state.ordersQuotesData,
          xField: 'category',
          yField: 'value',
          seriesField: 'type',
          isGroup: false,
          color: ['rgba(56, 135, 238, 1)'],
          legend: false,
          meta: { value: { min: 0, max: axisMax } },
          label: false,
          annotations,
          xAxis,
          yAxis,
          tooltip,
          style: styleObj,
          columnStyle,
          columnWidthRatio: resolveCssVarValue('--fs-xs') * 0.07547,
          maxColumnWidth: resolveCssVarValue('--fs-hero') * 2.8301886,
          animation: false,
          autoFit: true,
          appendPadding: smallCard
            ? [
                resolveCssVarValue('--sp-md2') * 1.132075,
                resolveCssVarValue('--sp-md2') * 1.132075,
                resolveCssVarValue('--sp-md2'),
                resolveCssVarValue('--sp-md2') * 1.132075
              ]
            : [
                resolveCssVarValue('--sp-lg') * 1.132075,
                resolveCssVarValue('--sp-md2') * 1.509434,
                resolveCssVarValue('--sp-md2'),
                resolveCssVarValue('--sp-md2') * 1.509434
              ]
        }
      };
    } else {
      if (this._ordersQuotesCache && this._ordersQuotesCache.config) {
        this._ordersQuotesCache.config.data = this.state.ordersQuotesData;
      }
    }
    if (
      !this._pickupDeliveryCache ||
      this._pickupDeliveryCache.data !== this.state.pickupDeliveryData
    ) {
      const tooltipPD = {
        shared: false,
        follow: true,
        showTitle: false,
        enterable: false,
        offset: -50,
        customContent: (title, items) => {
          if (!items || items.length === 0) return null;
          const item = items[0];
          if (!item) return null;
          const value = item.value;
          const name = item.name;
          const locationName = item.data?.location || title || '';
          return (
            <div
              style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 'calc(var(--sp-xxs)*2)',
                padding:
                  'calc(var(--sp-md2)*1.226415) calc(var(--sp-md2)*1.132075) calc(var(--sp-md2)*1.32075) calc(var(--sp-md2)*1.132075)',
                background: '#FFFFFF',
                border: '1px solid #E2E8F0',
                borderRadius: 'calc(var(--sp-xxs)*2)',
                boxShadow: '0 4px 12px rgba(15,23,42,0.08)',
                fontFamily: 'Inter, Arial, sans-serif',
                minWidth: resolveCssVarValue('--fs-hero') * 4.26886
              }}>
              <div
                style={{
                  position: 'absolute',
                  left: -resolveCssVarValue('--sp-sm'),
                  top: '30%',
                  transform: 'translateY(-50%)',
                  width: 0,
                  height: 0,
                  borderTop: 'var(--sp-sm) solid transparent',
                  borderBottom: 'var(--sp-sm) solid transparent',
                  borderRight: 'var(--sp-sm) solid #FFFFFF',
                  filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.15))'
                }}
              />
              <div
                style={{
                  fontSize: 'calc(var(--fs-xs)*1.32075)',
                  fontWeight: 600,
                  color: 'rgba(15, 23, 42, 1)',
                  marginBottom: resolveCssVarValue('--sp-xxs') * 0.45248
                }}>
                {locationName}
              </div>
              <div
                style={{
                  fontSize: 'calc(var(--fs-xs)*1.132075)',
                  fontWeight: 500,
                  color: 'rgba(126, 132, 146, 1)',
                  marginBottom: resolveCssVarValue('--sp-xxs')
                }}>{`${this.state.selectedDateRange?.[0]?.format(
                'MM-DD-YYYY'
              )} - ${this.state.selectedDateRange?.[1]?.format('MM-DD-YYYY')}`}</div>
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    style={{
                      width: 'var(--sp-md2)',
                      height: 'var(--sp-md2)',
                      borderRadius: '50%',
                      background: 'rgba(255, 255, 255, 1)',
                      border: `calc(var(--sp-xxs)*0.47169) solid ${item.color}`,
                      boxSizing: 'border-box',
                      display: 'inline-block',
                      marginRight: resolveCssVarValue('--sp-sm')
                    }}
                  />
                  <span
                    style={{
                      fontSize: 'calc(var(--fs-xs)*1.226415)',
                      fontWeight: 400,
                      color: 'rgba(0, 0, 0, 1)'
                    }}>
                    {name}
                  </span>
                </div>
                <span
                  style={{
                    fontSize: 'calc(var(--fs-xs)*1.4150943)',
                    fontWeight: 500,
                    color: 'rgba(0, 0, 0, 1)'
                  }}>
                  {value}
                </span>
              </div>
            </div>
          );
        },
        domStyles: {
          'g2-tooltip': { background: 'transparent', boxShadow: 'none', padding: 0 }
        }
      };
      const totalsMap = {};
      (this.state.pickupDeliveryData || []).forEach((d) => {
        totalsMap[d.location] = (totalsMap[d.location] || 0) + Number(d.value || 0);
      });
      const totals = Object.values(totalsMap);
      const rawPDMax = totals.length ? Math.max(...totals) : 0;
      const choosePDStep = (m) => {
        if (m <= 50) return 5;
        if (m <= 100) return 10;
        if (m <= 200) return 20;
        if (m <= 500) return 50;
        if (m <= 1000) return 100;
        if (m <= 2000) return 200;
        if (m <= 5000) return 500;
        if (m <= 10000) return 1000;
        if (m <= 20000) return 2000;
        if (m <= 50000) return 5000;
        return 10000;
      };
      const pdStep = choosePDStep(rawPDMax);
      let baseSnappedPDMax = Math.ceil((rawPDMax || 0) / pdStep) * pdStep;
      if (baseSnappedPDMax === 0) baseSnappedPDMax = pdStep;
      const axisPDMax = baseSnappedPDMax + 2 * pdStep;
      this._pickupDeliveryCache = {
        data: this.state.pickupDeliveryData,
        config: {
          style: { flex: 1, height: '100%' },
          data: this.state.pickupDeliveryData,
          xField: 'location',
          yField: 'value',
          seriesField: 'type',
          isStack: true,
          color: ({ type }) =>
            type === 'Pickup' ? 'rgba(177, 169, 239, 1)' : 'rgba(193, 201, 210, 1)',
          columnStyle: ({ type }) => {
            const isPickup = type === 'Pickup';

            const topColor = isPickup ? 'rgba(130, 116, 238, 1)' : 'rgba(180, 190, 205, 1)';

            const bottomColor = isPickup ? 'rgba(120, 105, 200, 1)' : 'rgba(145, 155, 170, 1)';

            return {
              radius: isPickup
                ? [resolveCssVarValue('--sp-sm'), resolveCssVarValue('--sp-sm'), 0, 0]
                : [0, 0, 0, 0],

              shadowColor: 'rgba(0, 0, 0, 0.25)',
              shadowBlur: resolveCssVarValue('--sp-md2'),
              shadowOffsetX: resolveCssVarValue('--sp-md2') * 0.28301,
              shadowOffsetY: resolveCssVarValue('--sp-md2') * 0.471698,

              fill: `l(90) 0:${topColor} 1:${bottomColor}`
            };
          },

          seriesOrder: ['Delivery', 'Pickup'],
          xAxis: {
            line: {
              style: {
                stroke: 'rgba(235, 235, 235, 1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
              }
            },
            tickCount: Math.floor(
              ((this.state.chartWidth || window.innerWidth) / resolveCssVarValue('--fs-hero')) *
                3.301886
            ),
            label: {
              style: {
                fill: 'rgba(152, 152, 152, 1)',
                offset: 12,
                fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                fontWeight: 500
              },
              autoRotate: false,
              autoHide: true,
              formatter: (text) => {
                if (!text) return '';
                const MAX_LEN = 8;
                if (text.length > MAX_LEN) {
                  return text.slice(0, MAX_LEN - 1) + '…';
                }
                return text;
              }
            },
            tickLine: null
          },
          yAxis: {
            max: axisPDMax,
            tickInterval: pdStep,
            line: {
              style: {
                stroke: 'rgba(235, 235, 235, 1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
              }
            },
            grid: {
              line: {
                style: (text, index, items) => {
                  const lastIndex = items.length - 1;
                  if (index === 0 || index === lastIndex) return { lineWidth: 0 };
                  return {
                    stroke: 'rgba(230,230,230,1)',
                    lineWidth: resolveCssVarValue('--fs-xs') * 0.18867,
                    lineDash: [4, 4]
                  };
                }
              }
            },
            tickLine: null,
            label: {
              style: {
                fill: 'rgba(152, 152, 152, 1)',
                fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                fontWeight: 500
              },
              formatter: (text) => {
                const v = Number(text);
                if (!isNaN(v) && v >= baseSnappedPDMax + pdStep) return '';
                return text;
              }
            }
          },
          tooltip: tooltipPD,
          legend: false,
          columnWidthRatio: resolveCssVarValue('--fs-xs') * 0.07547,
          maxColumnWidth: resolveCssVarValue('--fs-hero') * 1.6981132,
          animation: false,
          meta: { value: { min: 0, max: axisPDMax } },
          autoFit: true,
          appendPadding:
            (this.state.chartHeight || 0) < resolveCssVarValue('--fs-hero') * 8.49056
              ? [
                  resolveCssVarValue('--sp-md2') * 1.132075,
                  resolveCssVarValue('--sp-md2') * 1.132075,
                  resolveCssVarValue('--sp-md2'),
                  resolveCssVarValue('--sp-md2') * 1.132075
                ]
              : [
                  resolveCssVarValue('--sp-lg') * 1.132075,
                  resolveCssVarValue('--sp-md2') * 1.509434,
                  resolveCssVarValue('--sp-md2'),
                  resolveCssVarValue('--sp-md2') * 1.509434
                ]
        }
      };
    } else {
      this._pickupDeliveryCache.config.data = this.state.pickupDeliveryData;
    }
    if (!this._revenueTrendCache || this._revenueTrendCache.data !== revenueTrendData) {
      const rawRevMax = (revenueTrendData || []).length
        ? Math.max(...revenueTrendData.map((d) => d.value))
        : 0;
      const chooseRevStep = (m) => {
        if (m <= 1000) return 100;
        if (m <= 5000) return 500;
        if (m <= 20000) return 2000;
        if (m <= 50000) return 5000;
        if (m <= 100000) return 10000;
        return Math.pow(10, String(Math.floor(m)).length - 1);
      };
      const revStep = chooseRevStep(rawRevMax);
      let snappedRevMax = Math.ceil((rawRevMax || 0) / revStep) * revStep;
      if (snappedRevMax === 0) snappedRevMax = revStep;
      const axisRevMax = snappedRevMax + revStep;
      const tooltipRev = {
        customContent: (title, items) => {
          if (!items || !items.length) return '';
          const it = items[0];
          return `<div style=\"padding:calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1);font-size:calc(var(--fs-xs)*1.132075);\">\n<div style=\"font-weight:600;margin-bottom:calc(var(--sp-xxs)*1);\">${title}</div>\n<div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>${translate(
            'revenue'
          )}</span><span style=\"font-weight:600;\">${formatRevenue(
            it.data.value
          )}</span></div>\n</div>`;
        }
      };
      const revenueSeriesData = (revenueTrendData || []).map((d) => ({
        ...d,
        series: translate('revenue') || 'Revenue'
      }));
      this._revenueTrendCache = {
        data: revenueSeriesData,
        config: {
          data: revenueSeriesData || [],
          style: { flex: 1, height: '100%' },
          xField: 'period',
          yField: 'value',
          seriesField: 'series',
          color: ['rgba(177, 169, 239, 1)'],
          xAxis: {
            line: {
              style: {
                stroke: 'rgba(235, 235, 235, 1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
              }
            },
            tickLine: null,
            label: {
              style: {
                fill: 'rgba(152, 152, 152, 1)',
                fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                fontWeight: 500
              },
              formatter: (t) => this.formatPeriodLabel(t)
            }
          },
          yAxis: {
            max: axisRevMax,
            tickInterval: revStep,
            line: {
              style: {
                stroke: 'rgba(235, 235, 235, 1)',
                lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
              }
            },
            grid: {
              line: {
                style: (text, index, items) => {
                  const lastIndex = items.length - 1;
                  if (index === 0 || index === lastIndex) return { lineWidth: 0 };
                  return {
                    stroke: 'rgba(230,230,230,1)',
                    lineWidth: resolveCssVarValue('--fs-xs') * 0.18867,
                    lineDash: [4, 4]
                  };
                }
              }
            },
            label: {
              style: {
                fill: 'rgba(152, 152, 152, 1)',
                fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                fontWeight: 500
              },
              formatter: (v) => formatRevenue(Number(v))
            }
          },
          tooltip: tooltipRev,
          point: {
            size: resolveCssVarValue('--fs-xs') * 0.566037,
            shape: 'circle',
            style: {
              fill: '#FFFFFF',
              stroke: 'rgba(140, 128, 218, 1)',
              lineWidth: resolveCssVarValue('--fs-xs') * 0.283018,
              shadowColor: 'rgba(140, 128, 218, 0.4)',
              shadowBlur: resolveCssVarValue('--sp-xxs') * 2,
              shadowOffsetX: resolveCssVarValue('--sp-xxs') * 0.471698,
              shadowOffsetY: resolveCssVarValue('--sp-xxs') * 1
            }
          },

          interactions: [{ type: 'element-active' }],

          legend: false,
          lineStyle: {
            lineWidth: resolveCssVarValue('--fs-xs') * 0.283018,
            shadowColor: 'rgba(140, 128, 218, 0.35)',
            shadowBlur: resolveCssVarValue('--sp-md2'),
            shadowOffsetX: resolveCssVarValue('--sp-md2') * 0.188679,
            shadowOffsetY: resolveCssVarValue('--sp-xs') * 1
          },
          meta: { value: { min: 0, max: axisRevMax } },
          animation: false,
          autoFit: true,
          appendPadding:
            (this.state.chartHeight || 0) < resolveCssVarValue('--fs-hero') * 8.49056
              ? [
                  resolveCssVarValue('--sp-md2') * 1.132075,
                  resolveCssVarValue('--sp-md2') * 1.132075,
                  resolveCssVarValue('--sp-md2') * 1.5094,
                  resolveCssVarValue('--sp-md2') * 1.132075
                ]
              : [
                  resolveCssVarValue('--sp-lg') * 1.132075,
                  resolveCssVarValue('--sp-md2') * 1.509434,
                  resolveCssVarValue('--sp-lg') * 1.132075,
                  resolveCssVarValue('--sp-md2') * 1.509434
                ]
        }
      };
    } else {
      this._revenueTrendCache.config.data = (revenueTrendData || []).map((d) => ({
        ...d,
        series: translate('revenue') || 'Revenue'
      }));
    }
    if (this.state.selectedPickupDeliveryFilter === 'dailyOrderTrend') {
      const trendSrc = this.state.pickupDeliveryTrendData || [];
      const flattened = [];
      trendSrc.forEach((r) => {
        flattened.push({
          period: r.period,
          series: translate('pickup') || 'Pickup',
          value: r.Pickup
        });
        flattened.push({
          period: r.period,
          series: translate('delivery') || 'Delivery',
          value: r.Delivery
        });
      });

      const rawMax = flattened.length ? Math.max(...flattened.map((f) => f.value)) : 0;
      const chooseStep = (m) => {
        if (m <= 50) return 5;
        if (m <= 100) return 10;
        if (m <= 200) return 20;
        if (m <= 500) return 50;
        if (m <= 1000) return 100;
        if (m <= 2000) return 200;
        if (m <= 5000) return 500;
        if (m <= 10000) return 1000;
        if (m <= 20000) return 2000;
        if (m <= 50000) return 5000;
        return 10000;
      };
      const step = chooseStep(rawMax);
      let snapped = Math.ceil((rawMax || 0) / step) * step;
      if (snapped === 0) snapped = step;
      if (!this._pickupDeliveryTrendCache || this._pickupDeliveryTrendCache._hash !== trendSrc) {
        this._pickupDeliveryTrendCache = {
          _hash: trendSrc,
          config: {
            style: { flex: 1, height: '100%' },

            data: flattened,
            xField: 'period',
            yField: 'value',
            seriesField: 'series',
            color: ['rgba(177, 169, 239, 1)', 'rgba(193, 201, 210, 1)'],
            xAxis: {
              line: {
                style: {
                  stroke: 'rgba(235, 235, 235, 1)',
                  lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
                }
              },
              tickLine: null,
              label: {
                style: {
                  fill: 'rgba(152, 152, 152, 1)',
                  fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                  fontWeight: 500
                },
                formatter: (t) => this.formatPeriodLabel(t)
              }
            },
            yAxis: {
              max: snapped,
              tickInterval: step,
              line: {
                style: {
                  stroke: 'rgba(235, 235, 235, 1)',
                  lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
                }
              },
              grid: {
                line: {
                  style: (text, index, items) => {
                    const last = items.length - 1;
                    if (index === 0 || index === last) return { lineWidth: 0 };
                    return {
                      stroke: 'rgba(230,230,230,1)',
                      lineWidth: resolveCssVarValue('--fs-xs') * 0.18867,
                      lineDash: [4, 4]
                    };
                  }
                }
              },
              label: {
                style: {
                  fill: 'rgba(152, 152, 152, 1)',
                  fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                  fontWeight: 500
                }
              }
            },
            tooltip: {
              shared: true,
              customContent: (title, items) => {
                if (!items || !items.length) return '';
                const p = items.reduce((acc, it) => acc + Number(it.data.value || 0), 0);
                const rows = items
                  .map((it) => {
                    return `<div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xs)*2);margin-bottom:var(--sp-sm);margin-top:var(--sp-sm)\"><span>${it.data.series}</span><span style=\"font-weight:600;\">${it.data.value}</span></div>`;
                  })
                  .join('');
                return `<div style=\"padding:calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1.132075);font-size:calc(var(--fs-xs)*1.32075);\"><div style=\"font-weight:600;margin-bottom:var(--sp-xs);\">${title}</div><div style=\"margin-top:var(--sp-xs)\">${rows}</div><div style=\"margin-top:var(--sp-xxs);display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);border-top:calc(var(--fs-xs)*0.09433) solid #e2e8f0;padding-top:var(--sp-xxs);\"><span>Total</span><span style=\"font-weight:600;\">${p}</span></div></div>`;
              }
            },
            point: {
              size: resolveCssVarValue('--fs-xs') * 0.566037,
              shape: 'circle',
              style: (datum) => {
                const pickupLabel = translate('pickup') || 'Pickup';
                const isPickup = datum.series === pickupLabel;
                const pickupColor = 'rgba(140, 128, 218, 1)';
                const deliveryColor = 'rgba(163, 173, 188, 1)';
                const c = isPickup ? pickupColor : deliveryColor;

                return {
                  fill: '#FFFFFF',
                  stroke: c,
                  lineWidth: resolveCssVarValue('--fs-xs') * 0.283018,

                  shadowColor: isPickup ? 'rgba(140, 128, 218, 0.4)' : 'rgba(163, 173, 188, 0.4)',
                  shadowBlur: resolveCssVarValue('--sp-xxs') * 2,
                  shadowOffsetX: resolveCssVarValue('--sp-xxs') * 0.471698,
                  shadowOffsetY: resolveCssVarValue('--sp-xxs')
                };
              }
            },

            lineStyle: (datum) => {
              const pickupLabel = translate('pickup') || 'Pickup';
              const isPickup = datum.series === pickupLabel;

              return {
                lineWidth: resolveCssVarValue('--fs-xs') * 0.283018,

                shadowColor: isPickup ? 'rgba(140, 128, 218, 0.35)' : 'rgba(163, 173, 188, 0.35)',
                shadowBlur: resolveCssVarValue('--sp-md2'),
                shadowOffsetX: resolveCssVarValue('--sp-xxs') * 0.471698,
                shadowOffsetY: resolveCssVarValue('--sp-xs')
              };
            },

            animation: false,
            interactions: [{ type: 'element-active' }],

            legend: false,
            autoFit: true,
            appendPadding:
              (this.state.chartHeight || 0) < resolveCssVarValue('--fs-hero') * 8.49056
                ? [
                    resolveCssVarValue('--sp-md2') * 1.132075,
                    resolveCssVarValue('--sp-md2') * 1.132075,
                    resolveCssVarValue('--sp-md2'),
                    resolveCssVarValue('--sp-md2') * 1.132075
                  ]
                : [
                    resolveCssVarValue('--sp-lg') * 1.132075,
                    resolveCssVarValue('--sp-md2') * 1.509434,
                    resolveCssVarValue('--sp-md2'),
                    resolveCssVarValue('--sp-md2') * 1.509434
                  ]
          }
        };
      } else {
        this._pickupDeliveryTrendCache.config.data = flattened;
      }
    }
    let aggPickup = 0,
      aggDelivery = 0;
    (this.state.pickupDeliveryData || []).forEach((r) => {
      const val = Number(r.value || 0);
      if (r.type === 'Pickup') aggPickup += val;
      else if (r.type === 'Delivery') aggDelivery += val;
    });
    const aggTotalPD = aggPickup + aggDelivery;
    const aggPickupPct = aggTotalPD ? (aggPickup / aggTotalPD) * 100 : 0;
    const aggDeliveryPct = aggTotalPD ? (aggDelivery / aggTotalPD) * 100 : 0;
    const overallBreakdownPieData = [
      { type: translate('pickup') || 'Pickup', value: aggPickup },
      { type: translate('deliverySplit') || 'Delivery split', value: aggDelivery }
    ];
    const colorMap = {
      [translate('pickup') || 'Pickup']: 'rgba(140, 128, 218, 1)',
      [translate('deliverySplit') || 'Delivery split']: 'rgba(170, 182, 200, 1)'
    };
    const overallBreakdownPieConfig = {
      data: overallBreakdownPieData,
      angleField: 'value',
      colorField: 'type',
      color: [
        'l(270) 0:rgba(180, 170, 255, 1) 1:rgba(100, 85, 180, 1)',
        'l(270) 0:rgba(195, 205, 220, 1) 1:rgba(145, 160, 180, 1)'
      ],
      radius: 0.85,
      legend: false,
      animation: false,
      startAngle: -Math.PI / 2,
      endAngle: (3 * Math.PI) / 2,
      label: null,
      style: {
        width: resolveCssVarValue('--fs-hero') * 7.075471,
        height: resolveCssVarValue('--fs-hero') * 7.075471
      },
      pieStyle: {
        shadowColor: 'rgba(0, 0, 0, 0.4)',
        shadowBlur: resolveCssVarValue('--sp-md2') * 1.6981132,
        shadowOffsetX: resolveCssVarValue('--sp-sm'),
        shadowOffsetY: 0,
        stroke: 'rgba(255, 255, 255, 0.7)',
        lineWidth: resolveCssVarValue('--fs-xs') * 0.18867
      },
      interactions: [{ type: 'element-active' }],
      state: {
        active: {
          style: {
            lineWidth: resolveCssVarValue('--fs-xs') * 0.283018,
            stroke: '#FFFFFF'
          }
        }
      },
      tooltip: {
        customContent: (title, items) => {
          if (!items || !items.length) return '';
          const it = items[0];
          const value = it.data.value;
          const pctRaw = aggTotalPD ? (value / aggTotalPD) * 100 : 0;
          const pct =
            pctRaw % 1 === 0
              ? String(pctRaw)
              : pctRaw.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
          return (
            <div
              style={{
                position: 'relative',
                display: 'flex',
                backgroundColor: '#fff',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 'calc(var(--sp-md2)*1.132075)',
                padding:
                  'calc(var(--sp-md2)*1.226415) calc(var(--sp-md2)*1.132075) calc(var(--sp-md2)*1.32075) calc(var(--sp-md2)*1.132075)',
                border: '1px solid #E2E8F0',
                borderRadius: 'calc(var(--sp-xxs)*2)',
                boxShadow: '0 4px 12px rgba(15,23,42,0.08)',
                fontFamily: 'Inter, Arial, sans-serif',
                minWidth: resolveCssVarValue('--fs-hero') * 4.26886,
                minHeight: resolveCssVarValue('--fs-hero') * 1.7217
              }}>
              <div
                style={{
                  position: 'absolute',
                  left: -resolveCssVarValue('--sp-sm'),
                  top: '30%',
                  transform: 'translateY(-50%)',
                  width: 0,
                  height: 0,
                  borderTop: 'var(--sp-sm) solid transparent',
                  borderBottom: 'var(--sp-sm) solid transparent',
                  borderRight: 'var(--sp-sm) solid #FFFFFF',
                  filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.15))'
                }}
              />
              <div
                style={{
                  fontSize: 'calc(var(--fs-xs)*1.226415)',
                  fontWeight: 500,
                  color: 'rgba(126, 132, 146, 1)',
                  marginBottom: resolveCssVarValue('--sp-sm')
                }}>
                {`${this.state.selectedDateRange?.[0]?.format(
                  'MM-DD-YYYY'
                )} - ${this.state.selectedDateRange?.[1]?.format('MM-DD-YYYY')}`}
              </div>
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    style={{
                      width: 'var(--sp-md2)',
                      height: 'var(--sp-md2)',
                      borderRadius: '50%',
                      background: '#FFFFFF',
                      border: `calc(var(--sp-xxs)*0.471698) solid ${
                        colorMap[it.data.type] || '#000'
                      }`,
                      boxSizing: 'border-box',
                      display: 'inline-block',
                      marginRight: resolveCssVarValue('--sp-sm')
                    }}
                  />
                  <span
                    style={{
                      fontSize: 'calc(var(--fs-xs)*1.226415)',
                      fontWeight: 400,
                      color: 'rgba(0, 0, 0, 1)'
                    }}>
                    {it.data.type}
                  </span>
                </div>
                <span
                  style={{
                    fontSize: 'calc(var(--fs-xs)*1.4150943)',
                    fontWeight: 500,
                    color: 'rgba(0, 0, 0, 1)'
                  }}>
                  {pct}%
                </span>
              </div>
            </div>
          );
        },
        domStyles: {
          'g2-tooltip': { background: 'transparent', boxShadow: 'none', padding: 0 }
        }
      }
    };
    const { userInfo: { user, profile } = {} } = this.props;
    const isWhiteLabelOrWhiteLabelTeam = profile?.is_white_label_partner_team;

    return (
      <div style={{ backgroundColor: '#F8FAFC' }} className={css(styles.container)}>
        <div
          className="flex-row-center-between width-100"
          style={{ marginBottom: `calc(var(--sp-lg)*1.4150943)` }}>
          <PageTitleHeader title={translate('analytics') || 'Analytics'} />
          <div
            className="flex-row-center-between"
            style={{
              width: 'calc(var(--fs-hero)*13.67924)',
              gap: 'calc(var(--sp-md2)*1.8867924)'
            }}>
            {isWhiteLabelOrWhiteLabelTeam ? (
              <FormControl sx={{ width: 'calc(var(--fs-hero)*5.896226)' }}>
                <Select
                  displayEmpty
                  value={this.state.selectedId}
                  onChange={(e) => this.handleLocationChange(e.target.value)}
                  sx={{
                    height: 'calc(var(--fs-hero)*1.1556602)',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #D9D9D9',
                    borderRadius: 'var(--sp-sm)',
                    '& .MuiSelect-icon': {
                      width: 'calc(var(--fs-xs)*1.69811)',
                      height: 'calc(var(--fs-xs)*1.69811)',
                      color: '#64748B',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      right: 'calc(var(--sp-xxs)*2)'
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '0 calc(var(--sp-md2)*1.132075)',
                      fontSize: 'calc(var(--fs-xs)*1.32075)',
                      fontWeight: 400,
                      lineHeight: 'calc(var(--sp-lg)*1.6)',
                      color: '#334155'
                    },
                    '& .MuiSelect-select': {
                      fontSize: 'var(--fs-md2)',
                      lineHeight: 'calc(var(--sp-lg)*1.6)',
                      paddingTop: 'calc(var(--sp-xxs)*1.5)',
                      paddingBottom: 'calc(var(--sp-xxs)*1.5)'
                    }
                  }}
                  renderValue={(selected) => {
                    if (selected === undefined || selected === null) {
                      return (
                        <span style={{ color: '#64748B' }}>
                          {translate('selectLocation') || 'Select Location'}
                        </span>
                      );
                    }
                    const selectedOption = this.state.locationOptions.find(
                      (opt) => opt.value === selected
                    );
                    return selectedOption ? selectedOption.label : 'All Locations';
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 'calc(var(--fs-hero)*6.6037)',
                        backgroundColor: '#FFFFFF'
                      },
                      onScroll: (event) => {
                        this.handleLocationScroll(event);
                      }
                    }
                  }}>
                  {this.state.locationOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>
                      {option.label}
                    </MenuItem>
                  ))}
                  {(this.state.locationLoadingMore || this.state.locationLoading) && (
                    <MenuItem disabled>
                      <CustomSpinner size={resolveCssVarValue('--fs-xl') * 1.132075} />
                      <span
                        style={{
                          marginLeft: 'var(--sp-sm)',
                          fontSize: 'calc(var(--fs-xs)*1.32075)'
                        }}>
                        Loading...
                      </span>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            ) : (
              <div style={{ width: 'calc(var(--fs-hero)*5.896226)', visibilty: 'hidden' }}></div>
            )}
            <RangePicker
              presets={rangePresets}
              popupClassName="analytics-datepicker-dropdown"
              suffixIcon={
                <img
                  src={iconCal}
                  style={{
                    width: 'calc(var(--fs-xl)*1.226415)',
                    height: 'calc(var(--fs-xl)*1.226415)'
                  }}
                />
              }
              style={{
                width: 'calc(var(--fs-hero)*6.839622)',
                height: 'calc(var(--fs-hero)*1.1556602)',
                borderRadius: 'var(--sp-xs)'
              }}
              value={selectedDateRange}
              onChange={this.handleDateChange}
              format={US_DATE_FORMAT}
              allowClear={false}
              separator={
                <OpenInFullIcon
                  style={{
                    transform: 'rotate(45deg)',
                    fontSize: `calc(var(--fs-xs)*1.32075) !important`,
                    color: '#000',
                    fontWeight: '400'
                  }}
                />
              }
            />
          </div>
        </div>
        <Divider style={{ border: '1px solid rgba(221, 221, 221, 1)' }} />
        <Row
          className="kpi-row"
          gutter={[
            resolveCssVarValue('--sp-lg') * 1.132075,
            resolveCssVarValue('--sp-lg') * 1.132075,
            resolveCssVarValue('--sp-lg') * 1.132075
          ]}
          style={{ marginBottom: 'calc(var(--sp-md2)*1.886792)' }}>
          {dashboardContent.map((item, index) => {
            const colors = cardColors[index % cardColors.length];

            return (
              <Col key={index} className="kpi-col" xs={24} sm={12} md={8} lg={4} xl={4}>
                <div
                  ref={(el) => {
                    this.kpiRefs[index] = el;
                  }}
                  style={{
                    borderRadius: 'var(--sp-md2)',
                    padding:
                      'calc(var(--sp-md2)*1.32075) calc(var(--sp-md2)*1.32075) calc(var(--sp-md2)*1.226415) calc(var(--sp-md2)*1.415094)',
                    position: 'relative',
                    overflow: 'hidden',

                    // Professional subtle shadow
                    boxShadow: kpiCardShadow,

                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    // Light professional border + elegant top accent
                    border: '1px solid #E8EAED',
                    borderTop: `calc(var(--fs-xs)*0.377) solid ${colors.accent}`,

                    gap: 'calc(var(--sp-md2)*1.509433)',
                    boxSizing: 'border-box',
                    height: this.state.kpiMeasuring
                      ? 'auto'
                      : this.state.kpiCardHeight
                      ? this.state.kpiCardHeight
                      : undefined,

                    transition: 'box-shadow 0.3s ease, transform 0.3s ease, background 0.3s ease',
                    cursor: 'default'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = kpiCardHoverShadow;
                    e.currentTarget.style.transform = 'translateY(calc(var(--sp-xxs)*-0.5))';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = kpiCardShadow;
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 'calc(var(--sp-xs)*0.5)'
                    }}>
                    <TextBase
                      color={'#667085'}
                      size={'calc(var(--fs-xs)*1.60377)'}
                      style={{
                        fontWeight: 600,
                        letterSpacing: 'calc(var(--fs-xs)*0.0471698)'
                      }}>
                      {translate(item.title)}
                    </TextBase>

                    {(item.key === 'acceptance_rate' || item.key === 'average_reply_time') && (
                      <Tooltip
                        title={metricDescriptions[item.key]}
                        arrow
                        placement="top"
                        overlayInnerStyle={{
                          fontSize: 'calc(var(--fs-xs)*1.2)',
                          padding: 'var(--sp-sm) var(--sp-md2)'
                        }}>
                        <InfoOutlinedIcon
                          sx={{
                            fontSize: 'calc(var(--fs-xs)*1.886792)',
                            color: '#98A2B3',
                            cursor: 'pointer',
                            opacity: 0.85,
                            transition: 'opacity 0.2s, color 0.2s',
                            '&:hover': {
                              opacity: 1,
                              color: '#475467'
                            }
                          }}
                        />
                      </Tooltip>
                    )}
                  </div>

                  <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                    {this.state.kpiLoading ? (
                      <CustomSpinner size={resolveCssVarValue('--fs-xl')} />
                    ) : (
                      <TextBase
                        color={'#1A1A2E'}
                        fontWeight={700}
                        size={'calc(var(--fs-xl)*1.379245)'}
                        style={{
                          flex: 1,
                          letterSpacing: 'calc(var(--fs-xs)*-0.0471698)'
                        }}>
                        {item.key === 'revenue'
                          ? formatNumber(this.state.dashboardData[item.key])
                          : item.key === 'acceptance_rate'
                          ? `${this.state.dashboardData[item.key] || 0}%`
                          : item.key === 'average_reply_time'
                          ? formatReplyTime(this.state.dashboardData[item.key])
                          : this.state.dashboardData[item.key] || 0}
                      </TextBase>
                    )}
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
        {/* // FIRST ROW - Orders & Quotes + Pickup vs Delivery */}
        <Row
          gutter={[
            resolveCssVarValue('--sp-md2') * 1.32075,
            resolveCssVarValue('--sp-lg') * 1.132075,
            resolveCssVarValue('--sp-lg') * 1.132075
          ]}
          style={{
            borderRadius: 'calc(var(--sp-md2)*1)'
          }}>
          <Col
            span={12}
            xs={24}
            sm={12}
            md={12}
            style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                padding:
                  'calc(var(--sp-md2)*1.226415) calc(var(--sp-md2)*1.886792) calc(var(--sp-md2)*1.886792) calc(var(--sp-md2)*1.415094)',
                backgroundColor: Colors.white,
                boxShadow: '0px 1px 2px 1px #0000000D',
                display: 'flex',
                flexDirection: 'column',
                height: this.state.chartHeight,
                gap: 'calc(var(--sp-md2)*1.886792)',
                justifyContent: 'space-between',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #3B5BDB'
              }}>
              <div
                className="flex-row-center-between"
                style={{ marginBottom: 'calc(var(--sp-md2)*1.886792)' }}>
                <div>
                  <TextBase color={'#667085'} fontWeight={600} size={'calc(var(--fs-xs)*1.60377)'}>
                    {translate('ordersAndQuotes')}
                  </TextBase>
                </div>
                <Dropdown
                  trigger={['click']}
                  visible={this.state.showOQFilter}
                  onVisibleChange={(v) => this.setState({ showOQFilter: v })}
                  overlay={
                    <div
                      style={{
                        background: '#fff',
                        padding: 'calc(var(--sp-md2)*1)',
                        borderRadius: 'calc(var(--sp-sm)*1)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        width: 'calc(var(--fs-hero)*4.7169811)'
                      }}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 'calc(var(--sp-sm)*1.0)'
                        }}>
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            gap: 'calc(var(--sp-xxs)*2)'
                          }}>
                          <Checkbox
                            className="custom-checkbox"
                            checked={this.state.selectedOrdersQuotesCategories.includes(
                              'requestsReceived'
                            )}
                            onChange={() => this.toggleOQCategory('requestsReceived')}
                          />
                          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                            {translate('requestsReceived')}
                          </span>
                        </label>
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            gap: 'calc(var(--sp-xxs)*2)'
                          }}>
                          <Checkbox
                            className="custom-checkbox"
                            checked={this.state.selectedOrdersQuotesCategories.includes(
                              'quotationsSent'
                            )}
                            onChange={() => this.toggleOQCategory('quotationsSent')}
                          />
                          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                            {translate('quotesSent')}
                          </span>
                        </label>
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            gap: 'calc(var(--sp-xxs)*2)'
                          }}>
                          <Checkbox
                            className="custom-checkbox"
                            checked={this.state.selectedOrdersQuotesCategories.includes(
                              'quotationsAccepted'
                            )}
                            onChange={() => this.toggleOQCategory('quotationsAccepted')}
                          />
                          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                            {translate('quotesAccepted')}
                          </span>
                        </label>
                      </div>
                    </div>
                  }>
                  <div
                    className="cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    style={{
                      width: 'calc(var(--fs-hero)*4.7169811)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      background: '#FFFFFF',
                      border: '1px solid #D9D9D9',
                      borderRadius: 'calc(var(--sp-sm)*1)',
                      padding: `0 calc(var(--sp-md2)*1.132075)`,
                      height: 'calc(var(--fs-xl)*1.886792)',
                      fontSize: 'calc(var(--fs-xs)*1.32075)',
                      fontWeight: 400
                    }}>
                    <span
                      style={{
                        color: '#334155',
                        flex: 1,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}>
                      {this.oqSelectedLabel()}
                    </span>
                    <SVGImageComponentReact.IconArrowDown
                      style={{
                        marginLeft: 'calc(var(--sp-xxs)*2)',
                        width: 'calc(var(--fs-xs)*0.9433)',
                        height: 'calc(var(--fs-xs)*0.9433)'
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              {this.state.kpiLoading ? (
                this.renderSpinnerComponent()
              ) : (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                  <div style={{ flex: 1, minHeight: 0 }}>
                    <Column {...this._ordersQuotesCache.config} />
                  </div>
                  <div
                    title={this.oqSelectedLabel()}
                    style={{
                      marginTop: 'var(--sp-sm)',
                      marginLeft: 'calc(var(--sp-lg)*1.32075)',
                      fontSize: 'calc(var(--fs-xs)*1.132075)',
                      fontWeight: 400,
                      color: 'rgba(114, 114, 124, 1)',
                      lineHeight: 'calc(var(--fs-xs)*1.509433)',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                    {this.oqSelectedLabel()}
                  </div>
                </div>
              )}
            </div>
          </Col>

          <Col span={12} xs={24} sm={12} md={12}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                padding:
                  'calc(var(--sp-md2)*1.226415) calc(var(--sp-md2)*1.886792) calc(var(--sp-md2)*1.886792) calc(var(--sp-md2)*1.415094)',
                backgroundColor: Colors.white,
                boxShadow: '0px 1px 2px 1px #0000000D',
                display: 'flex',
                flexDirection: 'column',
                height: this.state.chartHeight,
                gap: 'calc(var(--sp-md2)*1.509433)',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #3B5BDB'
              }}>
              <div
                className="flex-row-center-between"
                style={{ marginBottom: 'calc(var(--sp-md2)*1.886792)' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'calc(var(--sp-md2)*1)',
                    flex: 1
                  }}>
                  <TextBase color={'#667085'} fontWeight={600} size={'calc(var(--fs-xs)*1.60377)'}>
                    {translate('pickupVsDelivery')}
                  </TextBase>
                  {this.state.selectedPickupDeliveryFilter === 'dailyOrderTrend' && (
                    <button
                      onClick={() => this.openFullViewChart('pickupDeliveryTrend')}
                      style={{
                        background:
                          'linear-gradient(135deg, rgba(177, 169, 239, 0.12) 0%, rgba(140, 128, 218, 0.08) 100%)',
                        border: '1px solid rgba(177, 169, 239, 0.3)',
                        cursor: 'pointer',
                        padding: 'calc(var(--sp-xxs)*1.132075)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 'calc(var(--sp-xxs)*1.5)',
                        fontSize: 'calc(var(--fs-xs)*1.509433)',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 2px 4px rgba(177, 169, 239, 0.1)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background =
                          'linear-gradient(135deg, rgba(177, 169, 239, 0.2) 0%, rgba(140, 128, 218, 0.15) 100%)';
                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(177, 169, 239, 0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background =
                          'linear-gradient(135deg, rgba(177, 169, 239, 0.12) 0%, rgba(140, 128, 218, 0.08) 100%)';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(177, 169, 239, 0.1)';
                      }}
                      title="Expand to full view">
                      <OpenInFullIcon
                        style={{
                          fontSize: `calc(var(--fs-xs)*1.6981132) !important`,
                          color: 'rgba(140, 128, 218, 1)'
                        }}
                      />
                    </button>
                  )}
                </div>

                <Dropdown
                  trigger={['click']}
                  visible={this.state.showPDFilter}
                  onVisibleChange={(v) => this.setState({ showPDFilter: v })}
                  overlay={
                    <div
                      style={{
                        background: '#fff',
                        padding: 'calc(var(--sp-md2)*1)',
                        borderRadius: 'var(--sp-sm)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        width: 'calc(var(--fs-hero)*4.7169811)'
                      }}>
                      <div
                        style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-sm)' }}>
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            gap: 'calc(var(--sp-xxs)*2)'
                          }}
                          onClick={() => {
                            this.setState({
                              selectedPickupDeliveryFilter: 'overallBreakdown',
                              showPDFilter: false
                            });
                          }}>
                          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                            {translate('overallBreakdown')}
                          </span>
                        </label>
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            gap: 'calc(var(--sp-xxs)*2)'
                          }}
                          onClick={() => {
                            const start = this.state.selectedDateRange[0].format('YYYY-MM-DD');
                            const end = this.state.selectedDateRange[1].format('YYYY-MM-DD');
                            const childId = this.state.selectedId;
                            this.getPickupDeliveryByLocation(start, end, childId, true);
                            this.setState({
                              selectedPickupDeliveryFilter: 'dailyOrderTrend',
                              showPDFilter: false
                            });
                          }}>
                          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                            {translate('dailyOrderTrend')}
                          </span>
                        </label>
                        <label
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            gap: 'calc(var(--sp-xxs)*2)'
                          }}
                          onClick={() => {
                            this.setState({
                              selectedPickupDeliveryFilter: 'byLocation',
                              showPDFilter: false
                            });
                          }}>
                          <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                            {translate('byLocation')}
                          </span>
                        </label>
                      </div>
                    </div>
                  }>
                  <div
                    className="cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    style={{
                      width: 'calc(var(--fs-hero)*4.7169811)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      background: '#FFFFFF',
                      border: '1px solid #D9D9D9',
                      borderRadius: 'calc(var(--sp-sm)*1)',
                      padding: `0 calc(var(--sp-md2)*1.132075)`,
                      height: 'calc(var(--fs-xl)*1.886792)',
                      lineHeight: 'calc(var(--fs-xl)*1.886792)',
                      fontSize: 'calc(var(--fs-xs)*1.32075)',
                      fontWeight: 400,
                      boxSizing: 'border-box'
                    }}>
                    <span
                      style={{
                        color: '#334155',
                        flex: 1,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}>
                      {this.state.selectedPickupDeliveryFilter === 'overallBreakdown' &&
                        translate('overallBreakdown')}
                      {this.state.selectedPickupDeliveryFilter === 'dailyOrderTrend' &&
                        translate('dailyOrderTrend')}
                      {this.state.selectedPickupDeliveryFilter === 'byLocation' &&
                        translate('byLocation')}
                    </span>
                    <SVGImageComponentReact.IconArrowDown
                      style={{
                        marginLeft: 'calc(var(--sp-xxs)*2)',
                        width: 'calc(var(--fs-xs)*0.9433)',
                        height: 'calc(var(--fs-xs)*0.9433)'
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              {this.state.pickupDeliveryLoading ? (
                this.renderSpinnerComponent()
              ) : (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                  {this.state.selectedPickupDeliveryFilter === 'overallBreakdown' ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1,
                        minHeight: 0,
                        justifyContent: 'space-around',
                        gap: 'calc(var(--sp-lg)*2.830188)'
                      }}>
                      <div
                        style={{
                          minHeight: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '60%'
                        }}>
                        <div
                          style={{
                            width: resolveCssVarValue('--fs-hero') * 7.075471,
                            height: resolveCssVarValue('--fs-hero') * 7.075471,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                          <Pie {...overallBreakdownPieConfig} />
                        </div>
                      </div>
                      <div
                        style={{
                          width: '20%',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          gap: convertPxToRem()
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: resolveCssVarValue('--sp-xxs') * 2,
                            fontSize: 'calc(var(--fs-xs)*1.32075)'
                          }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: resolveCssVarValue('--sp-xxs') * 2
                            }}>
                            <span
                              style={{
                                width: 'calc(var(--fs-xs)*1.5094)',
                                height: 'calc(var(--fs-xs)*1.5094)',
                                background: 'rgba(140, 128, 218, 1)',
                                borderRadius: 'var(--sp-xxs)',
                                display: 'inline-block'
                              }}
                            />
                            <span
                              style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                              {translate('pickup') || 'Pickup'}{' '}
                            </span>
                          </div>
                          <span
                            style={{
                              color: 'rgba(0, 0, 0, 1)',
                              fontSize: 'calc(var(--fs-xs)*2.35849)',
                              fontWeight: 500
                            }}>
                            {(() => {
                              const v = aggPickupPct;
                              if (!isFinite(v)) return '0%';
                              return (
                                (v % 1 === 0
                                  ? String(v)
                                  : v.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')) + '%'
                              );
                            })()}
                          </span>
                        </div>
                        <Divider
                          style={{ border: '1px solid rgba(235, 235, 235, 1)', margin: 0 }}
                        />
                        <div
                          style={{
                            display: 'flex',
                            gap: resolveCssVarValue('--sp-xxs') * 2,
                            flexDirection: 'column',
                            fontSize: 'calc(var(--fs-xs)*1.32075)'
                          }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: resolveCssVarValue('--sp-xxs') * 2
                            }}>
                            <span
                              style={{
                                width: 'calc(var(--fs-xs)*1.5094)',
                                height: 'calc(var(--fs-xs)*1.5094)',
                                background: 'rgba(170, 182, 200, 1)',
                                borderRadius: 'var(--sp-xxs)',
                                display: 'inline-block'
                              }}
                            />
                            <span
                              style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                              {translate('deliverySplit') || 'Delivery split'}{' '}
                            </span>
                          </div>
                          <span
                            style={{
                              color: 'rgba(0, 0, 0, 1)',
                              fontSize: 'calc(var(--fs-xs)*2.35849)',
                              fontWeight: 500
                            }}>
                            {(() => {
                              const v = aggDeliveryPct;
                              if (!isFinite(v)) return '0%';
                              return (
                                (v % 1 === 0
                                  ? String(v)
                                  : v.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')) + '%'
                              );
                            })()}
                          </span>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  ) : this.state.selectedPickupDeliveryFilter === 'dailyOrderTrend' ? (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          gap: resolveCssVarValue('--sp-md2') * 1.5094,
                          justifyContent: 'flex-end',
                          marginRight: 'var(--sp-xs)'
                        }}>
                        {[
                          {
                            key: 'Pickup',
                            color: 'rgba(177, 169, 239, 1)',
                            label: translate('pickup') || 'Pickup'
                          },
                          {
                            key: 'Delivery',
                            color: 'rgba(193, 201, 210, 1)',
                            label: translate('deliverySplit') || 'Delivery split'
                          }
                        ].map((item) => (
                          <div
                            key={item.key}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: 'calc(var(--fs-xs)*1.32075)',
                              fontWeight: 400,
                              color: '#000',
                              gap: 'calc(var(--sp-md2)*1.037735)'
                            }}>
                            <span
                              style={{
                                width: 'calc(var(--fs-xs)*1.5094)',
                                height: 'calc(var(--fs-xs)*1.5094)',
                                background: item.color,
                                borderRadius: 'var(--sp-xxs)',
                                display: 'inline-block'
                              }}
                            />
                            <span>{item.label}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ flex: 1, minHeight: 0 }}>
                        {this._pickupDeliveryTrendCache ? (
                          <Line {...this._pickupDeliveryTrendCache.config} />
                        ) : null}
                      </div>
                      <div
                        title={this.oqSelectedLabel()}
                        style={{
                          marginTop: 'calc(var(--sp-xxs)*2)',
                          marginLeft: 'var(--sp-xxs)',
                          fontSize: 'calc(var(--fs-xs)*1.132075)',
                          color: '#334155',
                          lineHeight: 'calc(var(--fs-xs)*1.509433)',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}></div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          gap: 'calc(var(--sp-md2)*1.5094)',
                          justifyContent: 'flex-end',
                          marginRight: 'var(--sp-xs)'
                        }}>
                        {[
                          {
                            key: 'Pickup',
                            color: 'rgba(140, 128, 218, 1)',
                            label: translate('pickup') || 'Pickup'
                          },
                          {
                            key: 'Delivery',
                            color: 'rgba(163, 173, 188, 1)',
                            label: translate('deliverySplit') || 'Delivery split'
                          }
                        ].map((item) => (
                          <div
                            key={item.key}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: 'calc(var(--fs-xs)*1.32075)',
                              fontWeight: 400,
                              color: '#000',
                              gap: 'calc(var(--sp-md2)*1.037735)'
                            }}>
                            <span
                              style={{
                                width: 'calc(var(--fs-xs)*1.5094)',
                                height: 'calc(var(--fs-xs)*1.5094)',
                                background: item.color,
                                borderRadius: 'var(--sp-xxs)',
                                display: 'inline-block'
                              }}
                            />
                            <span>{item.label}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ flex: 1, minHeight: 0 }}>
                        <Column {...this._pickupDeliveryCache.config} />
                      </div>
                      <div
                        title={this.oqSelectedLabel()}
                        style={{
                          marginTop: 'calc(var(--sp-xxs)*2)',
                          marginLeft: 'var(--sp-xxs)',
                          fontSize: 'calc(var(--fs-xs)*1.132075)',
                          color: '#334155',
                          lineHeight: 'calc(var(--fs-xs)*1.509433)',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}></div>
                    </>
                  )}
                </div>
              )}
            </div>
          </Col>
        </Row>
        {/* // SECOND ROW - Revenue Trends */}
        <Row
          style={{ marginTop: 'calc(var(--sp-md2)*1.32075)' }}
          gutter={[
            resolveCssVarValue('--sp-md2') * 1.32075,
            resolveCssVarValue('--sp-md2') * 1.32075
          ]}>
          <Col span={12} xs={24} sm={24} md={12}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                padding:
                  'calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.41509)',
                backgroundColor: Colors.white,
                boxShadow: '0px 1px 2px 1px #0000000D',
                display: 'flex',
                flexDirection: 'column',
                height: this.state.chartHeight,
                gap: 'calc(var(--sp-md2)*1.509433)',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #0CA678'
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-md2)*1)' }}>
                <TextBase color={'#667085'} fontWeight={600} size={'calc(var(--fs-xs)*1.60377)'}>
                  {translate('revenueTrendOverTime')}
                </TextBase>
                <button
                  onClick={() => this.openFullViewChart('revenueTrend')}
                  style={{
                    background:
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.12) 0%, rgba(140, 128, 218, 0.08) 100%)',
                    border: '1px solid rgba(177, 169, 239, 0.3)',
                    cursor: 'pointer',
                    padding: 'calc(var(--sp-xxs)*1.132075)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 'calc(var(--sp-xxs)*1.5)',
                    fontSize: 'calc(var(--fs-xs)*1.509433)',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 4px rgba(177, 169, 239, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.2) 0%, rgba(140, 128, 218, 0.15) 100%)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(177, 169, 239, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.12) 0%, rgba(140, 128, 218, 0.08) 100%)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(177, 169, 239, 0.1)';
                  }}
                  title="Expand to full view">
                  <OpenInFullIcon
                    style={{
                      fontSize: `calc(var(--fs-xs)*1.6981132) !important`,
                      color: 'rgba(140, 128, 218, 1)'
                    }}
                  />
                </button>
              </div>
              {this.state.revenueTrendLoading ? (
                this.renderSpinnerComponent()
              ) : (
                <>
                  <div style={{ flex: 1, minHeight: 0 }}>
                    <Line {...this._revenueTrendCache.config} />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 'calc(var(--fs-xs)*1.32075)',
                      fontWeight: 400,
                      color: '#000',
                      gap: 'calc(var(--sp-md2)*1.32075)'
                    }}>
                    <span
                      style={{
                        width: 'calc(var(--sp-md2)*1.50943)',
                        height: 'calc(var(--sp-md2)*1.50943)',
                        background: 'rgba(177,169,239,1)',
                        borderRadius: 'calc(var(--sp-md2)*0.377358)',
                        display: 'inline-block',
                        boxShadow: `0 0 0 1px rgba(177,169,239,1)`
                      }}
                    />
                    <span
                      style={{
                        fontSize: 'calc(var(--fs-xs)*1.32075)',
                        color: 'rgba(0, 0, 0, 1)',
                        fontWeight: 400
                      }}>
                      {translate('revenue') || 'Revenue'}
                    </span>
                  </div>
                </>
              )}
            </div>
          </Col>
          <Col span={12} xs={24} sm={24} md={12}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                padding:
                  'calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.41509)',
                backgroundColor: Colors.white,
                boxShadow: '0px 1px 2px 1px #0000000D',
                display: 'flex',
                flexDirection: 'column',
                height: this.state.chartHeight,
                gap: 'calc(var(--sp-md2)*1.509433)',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #0CA678'
              }}>
              <TextBase color={'#667085'} fontWeight={600} size={'calc(var(--fs-xs)*1.60377)'}>
                {`${translate('revenueByOrderType')} (${translate('pickupVsDelivery')})` ||
                  'Pickup vs Delivery Revenue'}
              </TextBase>
              {this.state.revenueByOrderTypeLoading ? (
                this.renderSpinnerComponent()
              ) : (
                <>
                  <div style={{ flex: 1, minHeight: 0 }}>
                    <Column
                      data={this.state.revenueByOrderTypeData || []}
                      isGroup
                      xField="period"
                      yField="value"
                      seriesField="type"
                      style={{ flex: 1, height: '100%' }}
                      dodgePadding={resolveCssVarValue('--sp-xxs')}
                      minColumnWidth={resolveCssVarValue('--fs-xs') * 2.3}
                      maxColumnWidth={resolveCssVarValue('--fs-xl') * 1.3}
                      appendPadding={
                        (this.state.chartHeight || 0) < resolveCssVarValue('--fs-hero') * 8.49056
                          ? [
                              resolveCssVarValue('--sp-md2') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.5094,
                              resolveCssVarValue('--sp-md2') * 1.132075
                            ]
                          : [
                              resolveCssVarValue('--sp-lg') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.509434,
                              resolveCssVarValue('--sp-lg') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.509434
                            ]
                      }
                      columnStyle={({ type }) => {
                        const isPickup = type === 'Pickup';

                        const topColor = isPickup
                          ? 'rgba(160, 150, 235, 1)'
                          : 'rgba(180, 190, 205, 1)';

                        const bottomColor = isPickup
                          ? 'rgba(120, 105, 200, 1)'
                          : 'rgba(145, 155, 170, 1)';
                        return {
                          radius: [4, 4, 0, 0],

                          shadowColor: 'rgba(0, 0, 0, 0.25)',
                          shadowBlur: resolveCssVarValue('--sp-md2'),
                          shadowOffsetX: resolveCssVarValue('--sp-md2') * 0.28301,
                          shadowOffsetY: resolveCssVarValue('--sp-md2') * 0.471698,

                          fill: `l(90) 0:${topColor} 1:${bottomColor}`
                        };
                      }}
                      color={(d) =>
                        d.type === 'Pickup' ? 'rgba(177, 169, 239, 1)' : 'rgba(193, 201, 210, 1)'
                      }
                      legend={false}
                      tooltip={{
                        customContent: (title, items) => {
                          if (!items || !items.length) return '';
                          const pickup = items.find((i) => i.data.type === 'Pickup');
                          const delivery = items.find((i) => i.data.type === 'Delivery');
                          return `<div style=\"padding:calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1);font-size:calc(var(--fs-xs)*1.132075);\"><div style=\"font-weight:600;margin-bottom:calc(var(--sp-xxs)*1);\">${title}</div>
                        <div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>Pickup</span><span style=\"font-weight:600;\">$${
                          pickup ? pickup.data.value : 0
                        }</span></div>
                        <div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>Delivery</span><span style=\"font-weight:600;\">$${
                          delivery ? delivery.data.value : 0
                        }</span></div>
                      </div>`;
                        }
                      }}
                      xAxis={{
                        label: {
                          style: {
                            fill: 'rgba(152, 152, 152, 1)',
                            fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                            fontWeight: 500
                          },
                          formatter: (t) => this.formatPeriodLabel(t)
                        },
                        line: {
                          style: {
                            stroke: 'rgba(235, 235, 235, 1)',
                            lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
                          }
                        },
                        tickLine: null
                      }}
                      yAxis={{
                        label: {
                          style: {
                            fill: 'rgba(152, 152, 152, 1)',
                            fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                            fontWeight: 500
                          },
                          formatter: (v) => `$${String(v)}`
                        },
                        line: {
                          style: {
                            stroke: 'rgba(235, 235, 235, 1)',
                            lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
                          }
                        },
                        grid: {
                          line: {
                            style: {
                              stroke: 'rgba(230,230,230,1)',
                              lineWidth: resolveCssVarValue('--fs-xs') * 0.09433,
                              lineDash: [4, 4]
                            }
                          }
                        }
                      }}
                      autoFit
                      animation={false}
                      meta={{ value: { min: 0 } }}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      gap: 'calc(var(--sp-md2)*1.50943)',
                      justifyContent: 'center'
                    }}>
                    {[
                      {
                        key: 'Pickup',
                        color: 'rgba(140, 128, 218, 1)',
                        label: translate('pickup') || 'Pickup'
                      },
                      {
                        key: 'Delivery',
                        color: 'rgba(163, 173, 188, 1)',
                        label: translate('delivery') || 'Delivery'
                      }
                    ].map((item) => (
                      <div
                        key={item.key}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: 'calc(var(--fs-xs)*1.32075)',
                          fontWeight: 400,
                          color: '#000',
                          gap: 'calc(var(--sp-md2)*1.0377)'
                        }}>
                        <span
                          style={{
                            width: 'calc(var(--fs-xs)*1.5094)',
                            height: 'calc(var(--fs-xs)*1.5094)',
                            background: item.color,
                            borderRadius: resolveCssVarValue('--sp-xxs'),
                            display: 'inline-block'
                          }}
                        />
                        <span>{item.label}</span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </Col>
        </Row>
        {/* // THIRD ROW - Revenue by Location + New vs Repeat Customers */}
        <Row
          style={{ marginTop: 'calc(var(--sp-md2)*1.32075)' }}
          gutter={[
            resolveCssVarValue('--sp-md2') * 1.32075,
            resolveCssVarValue('--sp-md2') * 1.32075
          ]}>
          <Col span={12} xs={24} sm={24} md={12}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                padding:
                  'calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.41509) calc(var(--sp-md2)*1.41509)',
                backgroundColor: Colors.white,
                boxShadow: '0px 1px 2px 1px #0000000D',
                display: 'flex',
                flexDirection: 'column',
                height: this.state.chartHeight,
                justifyContent: 'flex-start',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #E67700'
              }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'calc(var(--sp-md2)*1)',
                  marginBottom: 'calc(var(--sp-md2)*1.41509)'
                }}>
                <TextBase color={'#667085'} fontWeight={600} size={'calc(var(--fs-xs)*1.60377)'}>
                  {translate('revenueByLocation')}
                </TextBase>
                <button
                  onClick={() => this.openFullViewChart('revenueByLocation')}
                  style={{
                    background:
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.12) 0%, rgba(140, 128, 218, 0.08) 100%)',
                    border: '1px solid rgba(177, 169, 239, 0.3)',
                    cursor: 'pointer',
                    padding: 'calc(var(--sp-xxs)*1.132075)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 'calc(var(--sp-xxs)*1.5)',
                    fontSize: 'calc(var(--fs-xs)*1.509433)',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 4px rgba(177, 169, 239, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.2) 0%, rgba(140, 128, 218, 0.15) 100%)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(177, 169, 239, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.12) 0%, rgba(140, 128, 218, 0.08) 100%)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(177, 169, 239, 0.1)';
                  }}
                  title="Expand to full view">
                  <OpenInFullIcon
                    style={{
                      fontSize: `calc(var(--fs-xs)*1.6981132) !important`,
                      color: 'rgba(140, 128, 218, 1)'
                    }}
                  />
                </button>
              </div>
              {this.state.revenueByLocationLoading ? (
                this.renderSpinnerComponent()
              ) : (
                <>
                  <div
                    style={{
                      minHeight: 0,
                      paddingBottom: 'calc(var(--sp-xxs)*1)',
                      flex: 1,
                      height: '100%'
                    }}>
                    <Column
                      data={this.state.revenueByLocationData || []}
                      xField="label"
                      yField="value"
                      seriesField={'label'}
                      isGroup={false}
                      legend={false}
                      minColumnWidth={resolveCssVarValue('--fs-xs') * 1.6981132}
                      maxColumnWidth={resolveCssVarValue('--fs-xs') * 3.2075471}
                      columnStyle={(datum) => {
                        const map = this._revenueByLocationColorMap || {};
                        const baseColor = map[datum.label] || '#6366F1';

                        return {
                          radius: [
                            resolveCssVarValue('--sp-xxs'),
                            resolveCssVarValue('--sp-xxs'),
                            0,
                            0
                          ],
                          shadowColor: 'rgba(0, 0, 0, 0.25)',
                          shadowBlur: resolveCssVarValue('--sp-md2'),
                          shadowOffsetX: resolveCssVarValue('--sp-md2') * 0.28301,
                          shadowOffsetY: resolveCssVarValue('--sp-md2') * 0.471698,
                          fill: `l(90) 0:${baseColor}99 1:${baseColor}`,
                          fill: `l(90) 0:${baseColor}99 1:${baseColor}`
                        };
                      }}
                      color={(d) => {
                        const map = this._revenueByLocationColorMap || {};
                        return map[d.label] || '#6366F1';
                      }}
                      tooltip={{
                        customContent: (title, items) => {
                          if (!items || !items.length) return '';
                          const it = items[0];
                          return `<div style=\"padding:calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1.88679);font-size:calc(var(--fs-xs)*1.132075);\"><div style=\"font-weight:600;margin-bottom:calc(var(--sp-xxs)*1);\">${title}</div>
                        <div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>${
                          translate('revenue') || 'Revenue'
                        }</span><span style=\"font-weight:600;\">${
                            it?.data?.value || 0
                          }</span></div>
                      </div>`;
                        }
                      }}
                      style={{ flex: 1, height: '100%' }}
                      xAxis={{
                        label: {
                          style: {
                            fill: 'rgba(152, 152, 152, 1)',
                            fontSize: resolveCssVarValue('--fs-xs') * 1.132075,
                            fontWeight: 500
                          },
                          autoRotate: true,
                          autoRotateAngle: -45,
                          autoHide: true,
                          formatter: (text) => {
                            if (!text) return '';
                            const MAX_LEN = 8;
                            if (text.length > MAX_LEN) {
                              return text.slice(0, MAX_LEN - 1) + '…';
                            }
                            return text;
                          }
                        },
                        line: {
                          style: {
                            stroke: 'rgba(235, 235, 235, 1)',
                            lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
                          }
                        },
                        tickLine: null
                      }}
                      yAxis={{
                        label: {
                          style: {
                            fill: 'rgba(152, 152, 152, 1)',
                            fontSize: resolveCssVarValue('--fs-xs') * 1.226415,
                            fontWeight: 500
                          }
                        },
                        line: {
                          style: {
                            stroke: 'rgba(205, 213, 225, 1)',
                            lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
                          }
                        },
                        grid: {
                          line: {
                            style: (text, index, items) => {
                              const lastIndex = items.length - 1;
                              if (index === 0 || index === lastIndex) return { lineWidth: 0 };
                              return {
                                stroke: 'rgba(230,230,230,1)',
                                lineWidth: resolveCssVarValue('--fs-xs') * 0.18867,
                                lineDash: [4, 4]
                              };
                            }
                          }
                        }
                      }}
                      autoFit
                      animation={false}
                      meta={{ value: { min: 0 } }}
                      appendPadding={
                        (this.state.chartHeight || 0) < resolveCssVarValue('--fs-hero') * 8.49056
                          ? [
                              resolveCssVarValue('--sp-md2') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.132075,
                              resolveCssVarValue('--sp-lg') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.132075
                            ]
                          : [
                              resolveCssVarValue('--sp-lg') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.509434,
                              resolveCssVarValue('--sp-lg') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.509434
                            ]
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'center',
                      gap: 'calc(var(--sp-md2)*1.132075)',
                      flexWrap: 'wrap',
                      marginTop: 'auto',
                      paddingTop: 'calc(var(--sp-md2)*1.132075)'
                    }}>
                    {(this.state.revenueByLocationData || [])
                      .map((d) => d.label)
                      .filter((v, i, a) => a.indexOf(v) === i)
                      .map((label) => {
                        const color = (this._revenueByLocationColorMap || {})[label];
                        return (
                          <div
                            key={label}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                              gap: 'calc(var(--sp-xxs)*2)',
                              fontSize: 'calc(var(--fs-xs)*1.32075)',
                              fontWeight: 400,
                              color: '#000',
                              maxWidth: 'calc(var(--fs-hero)*2.8301886)'
                            }}
                            title={label}>
                            <span
                              style={{
                                width: 'calc(var(--fs-xs)*1.50943)',
                                height: 'calc(var(--fs-xs)*1.50943)',
                                background: color,
                                borderRadius: 'var(--sp-xxs)',
                                display: 'inline-block',
                                flexShrink: 0
                              }}
                            />
                            <span
                              style={{
                                fontSize: 'calc(var(--fs-xs)*1.32075)',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'inline-block',
                                lineHeight: 1.1,
                                maxWidth: 'calc(var(--fs-hero)*2.8301886)'
                              }}>
                              {label}
                            </span>
                          </div>
                        );
                      })}
                  </div>
                </>
              )}
            </div>
          </Col>
          <Col span={12} xs={24} sm={24} md={12}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                padding: `calc(var(--sp-md2)*1.886792) calc(var(--sp-md2)*1.886792) calc(var(--sp-md2)*1.886792) calc(var(--sp-md2)*1.4151)`,
                backgroundColor: Colors.white,
                boxShadow: '0px 1px 2px 1px #0000000D',
                display: 'flex',
                flexDirection: 'column',
                height: this.state.chartHeight,
                justifyContent: 'space-between',
                gap: 'calc(var(--sp-md2)*1.509433)',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #E67700'
              }}>
              <TextBase color={'#667085'} fontWeight={600} size={'calc(var(--fs-xs)*1.60377)'}>
                {translate('newVsRepeatCustomers') || 'Pickup vs Delivery Revenue'}
              </TextBase>
              {this.state.newRepeatCustomersLoading ? (
                this.renderSpinnerComponent()
              ) : (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flex: 1,
                      minHeight: 0,
                      justifyContent: 'space-around',
                      gap: 'calc(var(--sp-lg)*2.830188)'
                    }}>
                    <div
                      style={{
                        minHeight: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '60%'
                      }}>
                      <div
                        style={{
                          width: resolveCssVarValue('--fs-hero') * 7.075471,
                          height: resolveCssVarValue('--fs-hero') * 7.075471,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                        {(() => {
                          const dataSrc = (this.state.newRepeatCustomersPie || []).slice();
                          const repeatKey = translate('repeatCustomers') || 'Repeat Customers';
                          dataSrc.sort((a, b) =>
                            a.type === repeatKey && b.type !== repeatKey
                              ? -1
                              : b.type === repeatKey && a.type !== repeatKey
                              ? 1
                              : 0
                          );
                          const startAngle = -Math.PI / 2;
                          const endAngle = startAngle + Math.PI * 2;
                          const customerColorMap = {
                            [translate('repeatCustomers') || 'Repeat Customers']:
                              'rgba(30, 100, 200, 1)',
                            [translate('newCustomers') || 'New Customers']: 'rgba(145, 160, 180, 1)'
                          };
                          return (
                            <Pie
                              data={dataSrc}
                              angleField="value"
                              colorField="type"
                              radius={0.85}
                              startAngle={startAngle}
                              endAngle={endAngle}
                              color={(d) =>
                                d.type === repeatKey
                                  ? 'l(270) 0:rgba(100, 175, 255, 1) 1:rgba(30, 100, 200, 1)'
                                  : 'l(270) 0:rgba(195, 205, 220, 1) 1:rgba(145, 160, 180, 1)'
                              }
                              label={false}
                              statistic={false}
                              legend={false}
                              style={{
                                width: resolveCssVarValue('--fs-hero') * 7.075471,
                                height: resolveCssVarValue('--fs-hero') * 7.075471
                              }}
                              pieStyle={{
                                shadowColor: 'rgba(0, 0, 0, 0.4)',
                                shadowBlur: resolveCssVarValue('--sp-md2') * 1.6981132,
                                shadowOffsetX: resolveCssVarValue('--sp-sm'),
                                shadowOffsetY: 0,
                                stroke: 'rgba(255, 255, 255, 0.7)',
                                lineWidth: resolveCssVarValue('--fs-xs') * 0.18867
                              }}
                              interactions={[{ type: 'element-active' }]}
                              state={{
                                active: {
                                  style: {
                                    lineWidth: resolveCssVarValue('--fs-xs') * 0.283018,
                                    stroke: '#FFFFFF'
                                  }
                                }
                              }}
                              tooltip={{
                                customContent: (title, items) => {
                                  if (!items || !items.length) return '';
                                  const total = (this.state.newRepeatCustomersPie || []).reduce(
                                    (a, b) => a + (b.value || 0),
                                    0
                                  );
                                  const { data } = items[0];
                                  const pct =
                                    total > 0 ? ((data.value / total) * 100).toFixed(0) : '0';
                                  return `<div style="padding:calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1.88679);font-size:calc(var(--fs-xs)*1.132075);">
                                  <div style="display:flex;align-items:center;gap:var(--sp-sm);">
                                    <span style="width:calc(var(--fs-xs)*1);height:calc(var(--fs-xs)*1);border-radius:50%;background:${
                                      customerColorMap[data.type]
                                    };"></span>
                                    <b>${data.type}</b>
                                    <span style="margin-left:calc(var(--sp-xxs)*2);font-weight:600;white-space:nowrap;">${pct}%</span>
                                  </div>
                                </div>`;
                                }
                              }}
                              animation={false}
                            />
                          );
                        })()}
                      </div>
                    </div>

                    <div
                      style={{
                        width: '30%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: 'calc(var(--sp-md2)*1.88679)'
                      }}>
                      {(() => {
                        const repeatKey = translate('repeatCustomers') || 'Repeat Customers';
                        const newKey = translate('newCustomers') || 'New Customers';
                        const dataArr = (this.state.newRepeatCustomersPie || []).slice();
                        const total = dataArr.reduce((a, b) => a + (b.value || 0), 0);
                        const repeatObj = dataArr.find((d) => d.type === repeatKey) || { value: 0 };
                        const newObj = dataArr.find((d) => d.type === newKey) || { value: 0 };
                        const formatPct = (val) => {
                          if (!total) return '0%';
                          const raw = (val / total) * 100;
                          const str =
                            raw % 1 === 0
                              ? String(raw)
                              : raw.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
                          return str + '%';
                        };
                        return (
                          <>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 'calc(var(--sp-xxs)*2)',
                                fontSize: 'calc(var(--fs-xs)*1.32075)'
                              }}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 'calc(var(--sp-xxs)*2)'
                                }}>
                                <span
                                  style={{
                                    width: 'calc(var(--fs-xs)*1.50943)',
                                    height: 'calc(var(--fs-xs)*1.50943)',
                                    background: 'rgba(65, 138, 228, 1)',
                                    borderRadius: 'calc(var(--sp-xxs)*1)',
                                    display: 'inline-block'
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: 'calc(var(--fs-xs)*1.32075)',
                                    fontWeight: 400
                                  }}>
                                  {repeatKey}
                                </span>
                              </div>
                              <span
                                style={{
                                  color: 'rgba(0, 0, 0, 1)',
                                  fontSize: 'calc(var(--fs-xs)*2.35849)',
                                  fontWeight: 500
                                }}>
                                {formatPct(repeatObj.value)}
                              </span>
                            </div>
                            <Divider
                              style={{ border: '1px solid rgba(235, 235, 235, 1)', margin: 0 }}
                            />
                            <div
                              style={{
                                display: 'flex',
                                gap: 'calc(var(--sp-xxs)*2)',
                                flexDirection: 'column',
                                fontSize: 'calc(var(--fs-xs)*1.32075)'
                              }}>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 'calc(var(--sp-xxs)*2)'
                                }}>
                                <span
                                  style={{
                                    width: 'calc(var(--fs-xs)*1.50943)',
                                    height: 'calc(var(--fs-xs)*1.50943)',
                                    background: 'rgba(170, 182, 200, 1)',
                                    borderRadius: 'calc(var(--sp-xxs)*1)',
                                    display: 'inline-block'
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: 'calc(var(--fs-xs)*1.32075)',
                                    fontWeight: 400
                                  }}>
                                  {newKey}
                                </span>
                              </div>
                              <span
                                style={{
                                  color: 'rgba(0, 0, 0, 1)',
                                  fontSize: 'calc(var(--fs-xs)*2.35849)',
                                  fontWeight: 500
                                }}>
                                {formatPct(newObj.value)}
                              </span>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                    <div></div>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
        {/* // FOURTH ROW - Customer Preference + Pending Orders */}
        <Row
          style={{ marginTop: 'calc(var(--sp-md2)*1.32075)' }}
          gutter={[
            resolveCssVarValue('--sp-md2') * 1.32075,
            resolveCssVarValue('--sp-md2') * 1.32075
          ]}>
          <Col span={16} xs={24} sm={24} md={16}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                padding: `calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.415094)`,
                backgroundColor: Colors.white,
                boxShadow: '0px 1px 2px 1px #0000000D',
                display: 'flex',
                flexDirection: 'column',
                height: this.state.chartHeight,
                gap: 'calc(var(--sp-md2)*1.509433)',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #6741D9'
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-md2)*1)' }}>
                <TextBase color={'#667085'} fontWeight={600} size={'calc(var(--fs-xs)*1.60377)'}>
                  {`${translate('customerPreference')} (${translate('pickupVsDelivery')})` ||
                    'Pickup vs Delivery Revenue'}
                </TextBase>
                <button
                  onClick={() => this.openFullViewChart('customerPreference')}
                  style={{
                    background:
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.12) 0%, rgba(140, 128, 218, 0.08) 100%)',
                    border: '1px solid rgba(177, 169, 239, 0.3)',
                    cursor: 'pointer',
                    padding: 'calc(var(--sp-xxs)*1.132075)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 'calc(var(--sp-xxs)*1.5)',
                    fontSize: 'calc(var(--fs-xs)*1.509433)',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 4px rgba(177, 169, 239, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.2) 0%, rgba(140, 128, 218, 0.15) 100%)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(177, 169, 239, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      'linear-gradient(135deg, rgba(177, 169, 239, 0.12) 0%, rgba(140, 128, 218, 0.08) 100%)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(177, 169, 239, 0.1)';
                  }}
                  title="Expand to full view">
                  <OpenInFullIcon
                    style={{
                      fontSize: `calc(var(--fs-xs)*1.88679) !important`,
                      color: 'rgba(140, 128, 218, 1)'
                    }}
                  />
                </button>
              </div>
              {this.state.customerPreferenceLoading ? (
                this.renderSpinnerComponent()
              ) : (
                <>
                  <div style={{ flex: 1, minHeight: 0 }}>
                    <Column
                      data={this.state.customerPreferenceData || []}
                      isGroup
                      xField="period"
                      style={{ flex: 1, height: '100%' }}
                      yField="value"
                      seriesField="type"
                      dodgePadding={resolveCssVarValue('--sp-md2') * 1.50943}
                      minColumnWidth={resolveCssVarValue('--fs-hero') * 1.132075}
                      maxColumnWidth={resolveCssVarValue('--fs-hero') * 1.32075}
                      appendPadding={
                        (this.state.chartHeight || 0) < resolveCssVarValue('--fs-hero') * 8.49056
                          ? [
                              resolveCssVarValue('--sp-md2') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.5094,
                              resolveCssVarValue('--sp-md2') * 1.132075
                            ]
                          : [
                              resolveCssVarValue('--sp-lg') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.509434,
                              resolveCssVarValue('--sp-lg') * 1.132075,
                              resolveCssVarValue('--sp-md2') * 1.509434
                            ]
                      }
                      columnStyle={({ type }) => {
                        const isPickup = type === 'Pickup';

                        const topColor = isPickup
                          ? 'rgba(160, 150, 235, 1)'
                          : 'rgba(180, 190, 205, 1)';

                        const bottomColor = isPickup
                          ? 'rgba(120, 105, 200, 1)'
                          : 'rgba(145, 155, 170, 1)';

                        return {
                          radius: [
                            resolveCssVarValue('--sp-xxs'),
                            resolveCssVarValue('--sp-xxs'),
                            0,
                            0
                          ],
                          shadowColor: 'rgba(0, 0, 0, 0.25)',
                          shadowBlur: resolveCssVarValue('--sp-md2'),
                          shadowOffsetX: resolveCssVarValue('--sp-md2') * 0.28301,
                          shadowOffsetY: resolveCssVarValue('--sp-md2') * 0.471698,
                          fill: `l(90) 0:${topColor} 1:${bottomColor}`
                        };
                      }}
                      color={(d) =>
                        d.type === 'Pickup' ? 'rgba(177, 169, 239, 1)' : 'rgba(193, 201, 210, 1)'
                      }
                      legend={false}
                      tooltip={{
                        customContent: (title, items) => {
                          if (!items || !items.length) return '';
                          const pickup = items.find((i) => i.data.type === 'Pickup');
                          const delivery = items.find((i) => i.data.type === 'Delivery');
                          return `<div style=\"padding:calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1.88679);font-size:calc(var(--fs-xs)*1.132075);\"><div style=\"font-weight:600;margin-bottom:calc(var(--sp-xxs)*1);\">${title}</div>
                        <div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>Pickup</span><span style=\"font-weight:600;\">${
                          pickup ? pickup.data.value : 0
                        }</span></div>
                        <div style=\"display:flex;justify-content:space-between;gap:calc(var(--sp-xxs)*2);\"><span>Delivery</span><span style=\"font-weight:600;\">${
                          delivery ? delivery.data.value : 0
                        }</span></div>
                      </div>`;
                        }
                      }}
                      xAxis={{
                        label: {
                          style: {
                            fill: 'rgba(152, 152, 152, 1)',
                            fontSize: resolveCssVarValue('--fs-xs') * 1.32075,
                            fontWeight: 500
                          },
                          formatter: (t) => this.formatPeriodLabel(t)
                        },
                        line: {
                          style: {
                            stroke: 'rgba(235, 235, 235, 1)',
                            lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
                          }
                        },
                        tickLine: null
                      }}
                      yAxis={{
                        label: {
                          style: {
                            fill: 'rgba(152, 152, 152, 1)',
                            fontSize: resolveCssVarValue('--fs-xs') * 1.32075,
                            fontWeight: 500
                          }
                        },
                        line: {
                          style: {
                            stroke: 'rgba(235, 235, 235, 1)',
                            lineWidth: resolveCssVarValue('--fs-xs') * 0.09433
                          }
                        },
                        grid: {
                          line: {
                            style: {
                              stroke: 'rgba(230,230,230,1)',
                              lineWidth: resolveCssVarValue('--fs-xs') * 0.09433,
                              lineDash: [4, 4]
                            }
                          }
                        }
                      }}
                      autoFit
                      animation={false}
                      meta={{ value: { min: 0 } }}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      gap: 'calc(var(--sp-md2)*1.509433)',
                      justifyContent: 'center'
                    }}>
                    {[
                      {
                        key: 'Pickup',
                        color: 'rgba(140, 128, 218, 1)',
                        label: translate('pickup') || 'Pickup'
                      },
                      {
                        key: 'Delivery',
                        color: 'rgba(163, 173, 188, 1)',
                        label: translate('delivery') || 'Delivery'
                      }
                    ].map((item) => (
                      <div
                        key={item.key}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: 'calc(var(--fs-xs)*1.32075)',
                          fontWeight: 400,
                          color: '#000',
                          gap: 'calc(var(--sp-md2)*1.132075)',
                          justifyContent: 'center'
                        }}>
                        <span
                          style={{
                            width: 'calc(var(--fs-xs)*1.509433)',
                            height: 'calc(var(--fs-xs)*1.509433)',
                            background: item.color,
                            borderRadius: resolveCssVarValue('--sp-xxs'),
                            display: 'inline-block'
                          }}
                        />
                        <span style={{ verticalAlign: 'middle' }}>{item.label}</span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </Col>
          <Col span={8} xs={24} sm={24} md={8}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                padding: `calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1.415094)`,
                backgroundColor: Colors.white,
                boxShadow: '0px 1px 2px 1px #0000000D',
                display: 'flex',
                flexDirection: 'column',
                height: this.state.chartHeight,
                gap: 'calc(var(--sp-md2)*2.0754716)',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #6741D9'
              }}>
              <TextBase color={'#667085'} fontWeight={600} size={'calc(var(--fs-xs)*1.60377)'}>
                {translate('pendingOrdersByLocation') || 'Pending Orders by Location'}
              </TextBase>
              {this.state.pendingOrdersLoading ? (
                this.renderSpinnerComponent()
              ) : (
                <div style={{ minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                  {(() => {
                    const dataSrc = (this.state.pendingOrdersData || []).map((r) => ({
                      key: r.vendor_id,
                      vendor_business_name: r.vendor_business_name,
                      pending_orders: r.pending_orders
                    }));

                    const columns = [
                      {
                        title: (
                          <span style={headerTextStyle}>{translate('location') || 'Location'}</span>
                        ),
                        dataIndex: 'vendor_business_name',
                        key: 'vendor_business_name',
                        render: (text) => (
                          <span
                            style={{
                              fontSize: 'calc(var(--fs-xs)*1.32075)',
                              color: '#0F172A',
                              fontWeight: 500
                            }}>
                            {text}
                          </span>
                        )
                      },
                      {
                        title: (
                          <span style={headerTextStyle}>
                            {translate('pendingOrders') || 'Pending Orders'}
                          </span>
                        ),
                        dataIndex: 'pending_orders',
                        key: 'pending_orders',
                        align: 'right',
                        render: (val) => (
                          <span
                            style={{
                              fontSize: 'calc(var(--fs-xs)*1.32075)',
                              color: '#0F172A',
                              fontWeight: 500
                            }}>
                            {val}
                          </span>
                        )
                      }
                    ];
                    return (
                      <div
                        className="hide-scrollbar"
                        style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
                        <Table
                          className="pending-orders-table"
                          size="small"
                          pagination={false}
                          dataSource={dataSrc}
                          columns={columns}
                          style={{ minWidth: '100%' }}
                          rowKey="key"
                          locale={{
                            emptyText: (
                              <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)' }}>
                                {translate('noData') || 'No Data'}
                              </span>
                            )
                          }}
                        />
                      </div>
                    );
                  })()}
                </div>
              )}
            </div>
          </Col>
        </Row>
        <Row
          style={{ marginTop: 'calc(var(--sp-md2)*1.32075)' }}
          gutter={[
            resolveCssVarValue('--sp-md2') * 1.32075,
            resolveCssVarValue('--sp-md2') * 1.32075
          ]}>
          <Col span={24} xs={24} sm={24} md={24}>
            <div
              className="width-100"
              style={{
                background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)',
                borderRadius: 'calc(var(--sp-md2)*1)',
                boxShadow: `
          0px 1px 3px rgba(0, 0, 0, 0.08),
          0px 4px 12px rgba(0, 0, 0, 0.12),
          0px 12px 24px rgba(0, 0, 0, 0.05)
        `,
                padding:
                  'calc(var(--sp-md2)*1.886792) calc(var(--sp-md2)*1.415094) calc(var(--sp-md2)*1.60377) calc(var(--sp-md2)*1.415094)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'pointer',
                borderTop: 'calc(var(--fs-xs)*0.377) solid #1A5A78'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = `
          0px 2px 4px rgba(0, 0, 0, 0.1),
          0px 8px 16px rgba(0, 0, 0, 0.15),
          0px 16px 32px rgba(0, 0, 0, 0.08)
        `;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = `
          0px 1px 3px rgba(0, 0, 0, 0.08),
          0px 4px 12px rgba(0, 0, 0, 0.12),
          0px 12px 24px rgba(0, 0, 0, 0.05)
        `;
              }}>
              <div style={{ marginBottom: 'calc(var(--sp-md2)*1.886792)' }}>
                <TextBase
                  color={'#667085'}
                  fontWeight={600}
                  size={'calc(var(--fs-xs)*1.60377)'}
                  style={{
                    letterSpacing: '0.5px'
                  }}>
                  {translate('latestOrders')}
                </TextBase>
              </div>

              <Table
                className="latest-orders-table no-row-hover"
                style={{ width: '100%' }}
                columns={this.columns.map((col) => ({
                  ...col,
                  headerCellStyle: {
                    background: '#1A5A78',
                    color: '#FFFFFF',
                    fontWeight: 700,
                    border: 'none'
                  }
                }))}
                dataSource={this.state.orders.map((order, idx) => ({
                  ...order,
                  key: order.id || idx
                }))}
                loading={{ spinning: this.state.latestOrdersLoading, indicator: <CustomSpinner /> }}
                pagination={false}
                onChange={this.handleTableChange}
                rowClassName={(record, index) => (index % 2 === 0 ? 'even-row' : 'odd-row')}
              />

              {!this.state.latestOrdersLoading &&
                this.state.orders.length > 0 &&
                (() => {
                  const page = this.state.latestOrdersPage || 1;
                  const size = this.state.latestOrdersPageSize || 10;
                  const total = this.state.latestOrdersTotal || this.state.orders?.length || 0;
                  const totalPages = Math.max(1, Math.ceil(total / size));
                  const start = total === 0 ? 0 : (page - 1) * size + 1;
                  const end = total === 0 ? 0 : Math.min(page * size, total);
                  const pageItems = buildPageList(page, totalPages, 1, 1);
                  const canPrev = page > 1;
                  const canNext = page < totalPages;

                  const pill = (active) => ({
                    padding: 'calc(var(--sp-xxs)*0.5) calc(var(--sp-md2)*0.8)',
                    borderRadius: '50%',
                    background: active ? 'rgba(26, 90, 120, 0.15)' : 'transparent',
                    color: active ? '#1A5A78' : '#6B7280',
                    fontWeight: active ? 700 : 600,
                    fontSize: 'calc(var(--fs-xs)*1.226415)',
                    lineHeight: 1,
                    height: 'calc(var(--fs-xl)*1.60377)',
                    width: 'calc(var(--fs-xl)*1.60377)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    border: active ? '1px solid rgba(26, 90, 120, 0.2)' : 'none',
                    transition: 'all 0.2s ease'
                  });

                  const iconBtn = (disabled) => ({
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'calc(var(--fs-xl)*1.5)',
                    height: 'calc(var(--fs-xl)*1.5)',
                    borderRadius: '50%',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    color: disabled ? '#D1D5DB' : '#1A5A78',
                    opacity: disabled ? '0.5' : '1',
                    transition: 'all 0.2s ease',
                    background: disabled ? 'transparent' : 'rgba(26, 90, 120, 0.05)',
                    border: disabled ? 'none' : '1px solid rgba(26, 90, 120, 0.1)'
                  });

                  const setPage = (p) => this.handleLatestOrdersPageChange(p, size);
                  const setSize = (newSize) => this.handleLatestOrdersPageChange(1, newSize);

                  return (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 'calc(var(--sp-md2)*1.1320075)',
                        marginTop: 'calc(var(--sp-md2)*2.132075)',
                        flexWrap: 'wrap',
                        padding: 'calc(var(--sp-md2)*1.415094) 0 0 0',
                        borderTop: '1px solid rgba(229, 231, 235, 1)'
                      }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'calc(var(--sp-md2)*1.415094)'
                        }}>
                        <span
                          style={{
                            color: '#1A5A78',
                            fontSize: 'calc(var(--fs-xs)*1.226415)',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.3px'
                          }}>
                          {translate('rowsPerPage') || 'Rows per page'}
                        </span>
                        <AntSelect
                          className="custom-ant-select"
                          value={size}
                          onChange={setSize}
                          size="small"
                          style={{
                            width: 'calc(var(--fs-hero)*1.809433)',
                            borderColor: '#1A5A78'
                          }}
                          options={[10, 20, 50].map((v) => ({ label: String(v), value: v }))}
                        />
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'calc(var(--sp-md2)*1.88679)',
                          flexWrap: 'wrap',
                          justifyContent: 'center',
                          marginRight: 'calc(var(--sp-md2)*0.377358)'
                        }}>
                        <div
                          style={{
                            color: '#6B7280',
                            fontSize: 'calc(var(--fs-xs)*1.132075)',
                            fontWeight: 600,
                            padding: '0 calc(var(--sp-md2)*0.5)',
                            background: 'rgba(26, 90, 120, 0.05)',
                            borderRadius: 'calc(var(--sp-xxs)*2)',
                            whiteSpace: 'nowrap'
                          }}>
                          <span style={{ color: '#1A5A78', fontWeight: 700 }}>
                            {`${start}-${end}`}
                          </span>
                          {` ${translate('of') || 'of'} `}
                          <span style={{ color: '#1A5A78', fontWeight: 700 }}>{total}</span>
                        </div>

                        <div
                          style={{
                            display: 'none'
                          }}>
                          <HorizontalRuleIcon
                            style={{
                              transform: 'rotate(-90deg)',
                              fontSize: 'calc(var(--fs-xl)*1.132075)'
                            }}
                          />
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 'calc(var(--sp-sm))'
                          }}>
                          <span
                            style={{
                              ...iconBtn(!canPrev),
                              cursor: !canPrev ? 'not-allowed' : 'pointer'
                            }}
                            onClick={() => canPrev && setPage(1)}
                            title={translate('first') || 'First'}
                            onMouseEnter={(e) => {
                              if (canPrev) {
                                e.currentTarget.style.background = 'rgba(26, 90, 120, 0.15)';
                                e.currentTarget.style.boxShadow =
                                  '0 4px 8px rgba(26, 90, 120, 0.15)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (canPrev) {
                                e.currentTarget.style.background = 'rgba(26, 90, 120, 0.05)';
                                e.currentTarget.style.boxShadow = 'none';
                              }
                            }}>
                            <FirstPageIcon style={{ fontSize: 'calc(var(--fs-xl)*1.232075)' }} />
                          </span>

                          <span
                            style={{
                              ...iconBtn(!canPrev),
                              cursor: !canPrev ? 'not-allowed' : 'pointer'
                            }}
                            onClick={() => canPrev && setPage(page - 1)}
                            title={translate('previous') || 'Previous'}
                            onMouseEnter={(e) => {
                              if (canPrev) {
                                e.currentTarget.style.background = 'rgba(26, 90, 120, 0.15)';
                                e.currentTarget.style.boxShadow =
                                  '0 4px 8px rgba(26, 90, 120, 0.15)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (canPrev) {
                                e.currentTarget.style.background = 'rgba(26, 90, 120, 0.05)';
                                e.currentTarget.style.boxShadow = 'none';
                              }
                            }}>
                            <KeyboardArrowLeftIcon
                              style={{ fontSize: 'calc(var(--fs-xl)*1.232075)' }}
                            />
                          </span>

                          {pageItems.map((it, idx) =>
                            it === '...' ? (
                              <span
                                key={`e-${idx}`}
                                style={{
                                  padding: '0 calc(var(--sp-sm)*0.5)',
                                  color: '#D1D5DB',
                                  fontSize: 'calc(var(--fs-xs)*1.6)'
                                }}>
                                …
                              </span>
                            ) : (
                              <span
                                key={it}
                                style={pill(it === page)}
                                onClick={() => it !== page && setPage(it)}
                                onMouseEnter={(e) => {
                                  if (it !== page) {
                                    e.currentTarget.style.background = 'rgba(26, 90, 120, 0.08)';
                                    e.currentTarget.style.color = '#1A5A78';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (it !== page) {
                                    e.currentTarget.style.background = 'transparent';
                                    e.currentTarget.style.color = '#6B7280';
                                  }
                                }}>
                                {it}
                              </span>
                            )
                          )}

                          <span
                            style={{
                              ...iconBtn(!canNext),
                              cursor: !canNext ? 'not-allowed' : 'pointer'
                            }}
                            onClick={() => canNext && setPage(page + 1)}
                            title={translate('next') || 'Next'}
                            onMouseEnter={(e) => {
                              if (canNext) {
                                e.currentTarget.style.background = 'rgba(26, 90, 120, 0.15)';
                                e.currentTarget.style.boxShadow =
                                  '0 4px 8px rgba(26, 90, 120, 0.15)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (canNext) {
                                e.currentTarget.style.background = 'rgba(26, 90, 120, 0.05)';
                                e.currentTarget.style.boxShadow = 'none';
                              }
                            }}>
                            <KeyboardArrowRightIcon
                              style={{ fontSize: 'calc(var(--fs-xl)*1.232075)' }}
                            />
                          </span>

                          <span
                            style={{
                              ...iconBtn(!canNext),
                              cursor: !canNext ? 'not-allowed' : 'pointer'
                            }}
                            onClick={() => canNext && setPage(totalPages)}
                            title={translate('last') || 'Last'}
                            onMouseEnter={(e) => {
                              if (canNext) {
                                e.currentTarget.style.background = 'rgba(26, 90, 120, 0.15)';
                                e.currentTarget.style.boxShadow =
                                  '0 4px 8px rgba(26, 90, 120, 0.15)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (canNext) {
                                e.currentTarget.style.background = 'rgba(26, 90, 120, 0.05)';
                                e.currentTarget.style.boxShadow = 'none';
                              }
                            }}>
                            <LastPageIcon style={{ fontSize: 'calc(var(--fs-xl)*1.232075)' }} />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })()}
            </div>
          </Col>
        </Row>
        {this.renderFullViewModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userDetail: getValueFromObjectByKeys(state, ['User', 'userDetail']),
    userInfo: getValueFromObjectByKeys(state, ['User', 'userInfo']),
    listNotification: getValueFromObjectByKeys(state, ['User', 'notification']),
    vendor: getValueFromObjectByKeys(state, ['User', 'vendor']),
    whiteLabel: getValueFromObjectByKeys(state, ['User', 'branding'])
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getDashboardTotal: (query) => {
      return dispatch(UserAction.getDashboardTotal(query));
    },
    getAcceptedOrders: (query) => {
      return dispatch(UserAction.getAcceptedOrders(query));
    },
    getNumberOfQuotes: (query) => {
      return dispatch(UserAction.getNumberOfQuotes(query));
    },
    getSearchAnalytics: (param) => {
      return dispatch(UserAction.getSearchAnalytics(param));
    },
    getAnalyticsCards: (param1, param2, param3) => {
      return dispatch(UserAction.getAnalyticsCards(param1, param2, param3));
    },
    getAnalyticsCardsWithoutEndDate: (param1, param2) => {
      return dispatch(UserAction.getAnalyticsCardsWithoutEndDate(param1, param2));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withNavigate(Analytics));
